"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[8181],{

/***/ 38490:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": () => (/* binding */ PatientDataSharingConsentModal)
});

// UNUSED EXPORTS: patientDataSharingTestId

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/ErrorOutline.js
var ErrorOutline = __webpack_require__(11829);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(5427);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Checkbox/Checkbox.js
var Checkbox = __webpack_require__(91241);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var dist_module = __webpack_require__(2550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-modal@0.3.9_vyafebljftw2lpwbgyprbkkpkm/node_modules/@elephant-healthcare/mui-modal/dist/module.js
var mui_modal_dist_module = __webpack_require__(27832);
// EXTERNAL MODULE: ./src/ui/index.ts + 7 modules
var ui = __webpack_require__(31630);
// EXTERNAL MODULE: ./src/client/observability/uxAnalytics/index.ts + 5 modules
var uxAnalytics = __webpack_require__(62463);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/tracing.ts
var tracing = __webpack_require__(75163);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+launchdarkly-provider@1.4.4_cn5jcockkrembw54osxy7yvfpi/node_modules/@elephant-healthcare/launchdarkly-provider/dist/module.js
var launchdarkly_provider_dist_module = __webpack_require__(45309);
// EXTERNAL MODULE: ./src/client/common/featureFlags/index.ts
var featureFlags = __webpack_require__(72766);
// EXTERNAL MODULE: ./src/client/patient-search/links.ts
var links = __webpack_require__(87268);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@6.15.0_react@18.1.0/node_modules/react-router/dist/index.js
var dist = __webpack_require__(76653);
// EXTERNAL MODULE: ./src/client/utils/useTerritory.ts
var useTerritory = __webpack_require__(29346);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+user-context-provider@1.3.0_whclspbtx7fcz5jo6nehkthzny/node_modules/@elephant-healthcare/user-context-provider/dist/module.js
var user_context_provider_dist_module = __webpack_require__(36547);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(28205);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/PatientDataSharingConsent/__generated__/PatientDataSharingConsentModal.gql.ts


const defaultOptions = {};
const PatientForDataSharingConsentDocument = lib/* gql */.Ps`
    query PatientForDataSharingConsent($uuid: String!, $searchWholeTerritory: Boolean) {
  patientByCardId(uuid: $uuid, searchWholeTerritory: $searchWholeTerritory) {
    patient {
      uuid
      consent {
        territoryUseOfData
      }
      clinic
      organisation
    }
  }
}
    `;
function usePatientForDataSharingConsentQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(PatientForDataSharingConsentDocument, options);
}
function usePatientForDataSharingConsentLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(PatientForDataSharingConsentDocument, options);
}
const UpdatePatientDataSharingConsentDocument = lib/* gql */.Ps`
    mutation UpdatePatientDataSharingConsent($uuid: String!, $consentsToDataSharing: Boolean!) {
  updatePatientDataSharingConsent(uuid: $uuid, consentsToDataSharing: $consentsToDataSharing) {
    uuid
  }
}
    `;
function useUpdatePatientDataSharingConsentMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(UpdatePatientDataSharingConsentDocument, options);
}

// EXTERNAL MODULE: ./src/client/components/PatientOverview/__generated__/queries.gql.ts
var queries_gql = __webpack_require__(94152);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/PatientDataSharingConsent/PatientDataSharingConsentModal.tsx


















lib/* gql */.Ps`
  query PatientForDataSharingConsent($uuid: String!, $searchWholeTerritory: Boolean) {
    patientByCardId(uuid: $uuid, searchWholeTerritory: $searchWholeTerritory) {
      patient {
        uuid
        consent {
          territoryUseOfData
        }
        clinic
        organisation
      }
    }
  }
`;
lib/* gql */.Ps`
  mutation UpdatePatientDataSharingConsent($uuid: String!, $consentsToDataSharing: Boolean!) {
    updatePatientDataSharingConsent(uuid: $uuid, consentsToDataSharing: $consentsToDataSharing) {
      uuid
    }
  }
`;
const componentName = "PatientDataSharingConsentModal";
const patientDataSharingTestId = {
  container: componentName,
  checkBoxButton: `${componentName}.checkBoxButton`,
  continueButton: `${componentName}.continueButton`,
  cancelButton: `${componentName}.cancelButton`
};
const useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  warning: {
    borderRadius: "5px"
  },
  warningBreakout: {
    background: theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: "8px"
  },
  warningIcon: {
    color: theme.palette.warning.main,
    height: 50,
    width: 50
  },
  checkbox: {
    paddingLeft: 0,
    paddingRight: 0
  },
  checkboxLabel: {
    cursor: "pointer",
    userSelect: "none"
  },
  backdrop: {
    backdropFilter: "blur(4px)"
  }
}));
const CHECKBOX_ID = "patient-consent-checkbox";
function PatientDataSharingConsentModal({
  patientId
}) {
  var _a, _b;
  const [consented, setConsented] = react.useState(false);
  const classes = useStyles();
  const { addEventToSpan } = (0,uxAnalytics/* useTracing */.kz)();
  const navigate = (0,dist/* useNavigate */.s0)();
  (0,uxAnalytics/* useMountSpan */.m0)(tracing/* PatientOverviewTracingSpans.DATA_SHARING_CONSENT_MODAL */.t.DATA_SHARING_CONSENT_MODAL);
  const territoryDataSharingFeatureEnabled = (0,launchdarkly_provider_dist_module/* useFeatureFlag */.ye)(
    featureFlags/* featureFlags.patient.territoryDataSharing */.VH.patient.territoryDataSharing
  );
  const territoryName = (0,useTerritory/* default */.Z)({ titleCase: true });
  const { organisationId } = (0,user_context_provider_dist_module/* useUserContext */.SE)();
  const { data: organisationData, loading: organisationLoading } = (0,queries_gql/* useOrganisationQuery */.n7)({
    variables: { organisationId }
  });
  const organisation = organisationData == null ? void 0 : organisationData.organisation;
  const { data: patientData, loading: patientDataLoading } = usePatientForDataSharingConsentQuery({
    variables: {
      uuid: patientId,
      searchWholeTerritory: territoryDataSharingFeatureEnabled
    }
  });
  const patient = (_a = patientData == null ? void 0 : patientData.patientByCardId) == null ? void 0 : _a.patient;
  const [updatePatientDataSharingConsent, { loading: submitting }] = useUpdatePatientDataSharingConsentMutation({
    update: (cache) => {
      cache.updateQuery(
        {
          query: PatientForDataSharingConsentDocument,
          variables: { uuid: patient.uuid, searchWholeTerritory: true }
        },
        (cachedData) => {
          var _a2, _b2, _c;
          return {
            patientByCardId: {
              ...cachedData == null ? void 0 : cachedData.patientByCardId,
              patient: {
                ...(_a2 = cachedData == null ? void 0 : cachedData.patientByCardId) == null ? void 0 : _a2.patient,
                consent: {
                  ...(_c = (_b2 = cachedData == null ? void 0 : cachedData.patientByCardId) == null ? void 0 : _b2.patient) == null ? void 0 : _c.consent,
                  territoryUseOfData: consented
                }
              }
            }
          };
        }
      );
    }
  });
  const handleUpdatePatientDataSharingConsent = (0,react.useCallback)(
    async (input) => {
      await updatePatientDataSharingConsent({
        variables: {
          uuid: patient.uuid,
          consentsToDataSharing: input.patientConsentsToShareData
        }
      });
    },
    [patient == null ? void 0 : patient.uuid, updatePatientDataSharingConsent]
  );
  const onClose = () => navigate((0,links/* linkToPatientSearch */.O)());
  const open = territoryDataSharingFeatureEnabled && !patientDataLoading && !organisationLoading && !((_b = patient == null ? void 0 : patient.consent) == null ? void 0 : _b.territoryUseOfData) && (patient == null ? void 0 : patient.organisation) !== (organisation == null ? void 0 : organisation.uuid);
  return /* @__PURE__ */ react.createElement(ui/* Modal */.u_, {
    open,
    onClose,
    "data-testid": patientDataSharingTestId.container,
    BackdropProps: {
      classes: {
        root: classes.backdrop
      }
    }
  }, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalHeader */.xB, {
    pb: 0
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h4",
    style: { marginBottom: 0 }
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.consent.dataSharing.title",
    defaultMessage: "Data access consent"
  }))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalBody */.fe, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    p: 2,
    display: "flex",
    mb: 2,
    className: classes.warningBreakout
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mr: 2
  }, /* @__PURE__ */ react.createElement(ErrorOutline/* default */.Z, {
    className: classes.warningIcon
  })), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.warningBreakout
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.consent.dataSharing.warningMessage",
    defaultMessage: "Please ensure that the following text is either shown or read to the patient, or their parent or guardian if the patient is under 18 years of age."
  }))), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mb: 2,
    p: 0.5
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    values: { organisationName: organisation == null ? void 0 : organisation.name, territoryName },
    id: "patient.consent.dataSharing.bodyMessage",
    defaultMessage: "We are using an online system called \u2018Elephant\u2019 to create electronic medical records. Currently your medical records are controlled by {organisationName} and can be used in facilities across that state. Do you give your consent for facilities across {territoryName} to be able to access your data?"
  }))), /* @__PURE__ */ react.createElement("label", {
    htmlFor: CHECKBOX_ID,
    className: classes.checkboxLabel
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mr: 2
  }, /* @__PURE__ */ react.createElement(Checkbox/* default */.Z, {
    autoFocus: true,
    color: "primary",
    id: CHECKBOX_ID,
    value: consented,
    onChange: (e) => {
      setConsented(e.target.checked);
    },
    className: classes.checkbox,
    inputProps: {
      "data-testid": patientDataSharingTestId.checkBoxButton
    }
  })), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.consent.dataSharing.tickBox",
    defaultMessage: "By ticking this box, you confirm that you are happy for us to process your or your child\u2019s data in this way."
  }))))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, {
    style: { display: "flex", gap: 8 }
  }, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: () => {
      addEventToSpan(
        tracing/* PatientOverviewTracingEvents */.R[tracing/* PatientOverviewTracingSpans.DATA_SHARING_CONSENT_MODAL */.t.DATA_SHARING_CONSENT_MODAL].CANCEL
      );
      onClose();
    },
    "data-testid": patientDataSharingTestId.cancelButton
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.consent.denyBtn",
    defaultMessage: "Cancel"
  })), /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "primary",
    onClick: () => {
      addEventToSpan(
        tracing/* PatientOverviewTracingEvents */.R[tracing/* PatientOverviewTracingSpans.DATA_SHARING_CONSENT_MODAL */.t.DATA_SHARING_CONSENT_MODAL].CONTINUE
      );
      handleUpdatePatientDataSharingConsent({
        patientConsentsToShareData: consented
      });
    },
    disabled: !consented,
    loading: submitting,
    "data-testid": patientDataSharingTestId.continueButton
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.consent.confirmationBtn",
    defaultMessage: "Accept & Continue"
  }))));
}


/***/ }),

/***/ 54598:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "ji": () => (/* binding */ InsuranceValidityChip),
/* harmony export */   "lu": () => (/* binding */ getCurrentInsuranceProviderName)
/* harmony export */ });
/* unused harmony export InsuranceStatus */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11313);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52018);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82682);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95061);
/* harmony import */ var _elephant_healthcare_mui_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10353);




var InsuranceStatus = /* @__PURE__ */ ((InsuranceStatus2) => {
  InsuranceStatus2["VALID"] = "valid";
  InsuranceStatus2["CHECK_PENDING"] = "check_pending";
  InsuranceStatus2["INVALID"] = "invalid";
  return InsuranceStatus2;
})(InsuranceStatus || {});
const insuranceStatusLabelMap = {
  ["valid" /* VALID */]: (0,react_intl__WEBPACK_IMPORTED_MODULE_1__/* .defineMessage */ .Em)({
    id: "patientDetails.header.insuranceStatus.valid",
    defaultMessage: "Valid"
  }),
  ["invalid" /* INVALID */]: (0,react_intl__WEBPACK_IMPORTED_MODULE_1__/* .defineMessage */ .Em)({
    id: "patientDetails.header.insuranceStatus.invalid",
    defaultMessage: "Invalid"
  }),
  ["check_pending" /* CHECK_PENDING */]: (0,react_intl__WEBPACK_IMPORTED_MODULE_1__/* .defineMessage */ .Em)({
    id: "patientDetails.header.insuranceStatus.checkPending",
    defaultMessage: "Unknown"
  })
};
const useInsuranceValidityChipStyles = (0,_elephant_healthcare_mui_style__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .Z)((theme) => {
  const colors = {
    ["valid" /* VALID */]: theme.palette.success,
    ["check_pending" /* CHECK_PENDING */]: theme.palette.darkerGrey,
    ["invalid" /* INVALID */]: theme.palette.error
  };
  return {
    chip: {
      color: ({ status }) => {
        var _a;
        return (_a = colors[status]) == null ? void 0 : _a.contrastText;
      },
      backgroundColor: ({ status }) => {
        var _a;
        return (_a = colors[status]) == null ? void 0 : _a.main;
      }
    }
  };
});
const getInsuranceProviderForVisit = (insurance, currentVisit) => currentVisit == null ? void 0 : currentVisit.insuranceList.filter(
  (i) => {
    var _a, _b;
    return ((_b = (_a = i == null ? void 0 : i.insurance) == null ? void 0 : _a.insuranceProvider) == null ? void 0 : _b.insuranceType) === (insurance == null ? void 0 : insurance.insuranceType);
  }
).pop();
function getChipStatus(props) {
  var _a;
  const { insurance, currentVisit } = props;
  if (!((_a = insurance.insuranceProvider) == null ? void 0 : _a.visitValidation)) {
    return "valid" /* VALID */;
  }
  const visitInsurance = getInsuranceProviderForVisit(insurance, currentVisit);
  const notYetValidated = !(visitInsurance == null ? void 0 : visitInsurance.visitInsuranceDetails) && !(visitInsurance == null ? void 0 : visitInsurance.isValidForVisit);
  if (!currentVisit || notYetValidated) {
    return "check_pending" /* CHECK_PENDING */;
  }
  return (visitInsurance == null ? void 0 : visitInsurance.isValidForVisit) ? "valid" /* VALID */ : "invalid" /* INVALID */;
}
const InsuranceValidityChip = (props) => {
  const { insurance, currentVisit } = props;
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const chipStatus = getChipStatus({ insurance, currentVisit });
  const classes = useInsuranceValidityChipStyles({ status: chipStatus });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    "data-testid": "insurance-chip",
    size: "small",
    label: formatMessage(insuranceStatusLabelMap[chipStatus]),
    className: classes.chip
  });
};
const useHeaderInsuranceStatusStyles = (0,_elephant_healthcare_mui_style__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .Z)((theme) => ({
  name: {
    marginRight: theme.spacing(1)
  }
}));
InsuranceValidityChip.defaultProps = {
  insurance: void 0,
  currentVisit: void 0
};
const getCurrentInsuranceProviderName = ({
  insurance,
  currentVisit
}) => {
  var _a, _b, _c, _d;
  const currentInsurance = getInsuranceProviderForVisit(
    insurance,
    currentVisit
  );
  return (_d = (_b = (_a = currentInsurance == null ? void 0 : currentInsurance.insurance) == null ? void 0 : _a.insuranceProvider) == null ? void 0 : _b.name) != null ? _d : (_c = insurance == null ? void 0 : insurance.insuranceProvider) == null ? void 0 : _c.name;
};
const HeaderInsuranceStatus = (props) => {
  const classes = useHeaderInsuranceStatusStyles(props);
  const { insurance, currentVisit } = props;
  if (!insurance)
    return null;
  const insuranceProvider = getCurrentInsuranceProviderName({
    insurance,
    currentVisit
  });
  if (!insuranceProvider)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "flex-end"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    "data-testid": "insurance.type.name",
    className: classes.name
  }, insuranceProvider), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InsuranceValidityChip, {
    insurance,
    currentVisit
  }));
};
HeaderInsuranceStatus.defaultProps = {
  insurance: void 0,
  currentVisit: void 0
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HeaderInsuranceStatus);


/***/ }),

/***/ 39158:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ PatientOverview_PatientDetailsHeader)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.2.6/node_modules/classnames/index.js
var classnames = __webpack_require__(97754);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-style@0.2.18_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-style/dist/module.js
var dist_module = __webpack_require__(10353);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-icon@0.3.15_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-icon/dist/module.js
var mui_icon_dist_module = __webpack_require__(46828);
// EXTERNAL MODULE: ./src/client/patient-queue/QueueDropdown.tsx + 2 modules
var QueueDropdown = __webpack_require__(882);
// EXTERNAL MODULE: ./src/client/utils/useQuerystring.ts
var useQuerystring = __webpack_require__(19894);
// EXTERNAL MODULE: ./src/client/utils/getCardId.ts
var getCardId = __webpack_require__(47274);
// EXTERNAL MODULE: ./src/client/patient-triage/TriageStatusDropdown.tsx + 7 modules
var TriageStatusDropdown = __webpack_require__(91549);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Popover/Popover.js
var Popover = __webpack_require__(28168);
// EXTERNAL MODULE: ./src/client/services/dayjs.js
var dayjs = __webpack_require__(15063);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@6.15.0_react@18.1.0/node_modules/react-router/dist/index.js
var dist = __webpack_require__(76653);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var mui_button_dist_module = __webpack_require__(2550);
// EXTERNAL MODULE: ./src/client/utils/useTerritory.ts
var useTerritory = __webpack_require__(29346);
// EXTERNAL MODULE: ./src/client/utils/constants.ts
var constants = __webpack_require__(20589);
// EXTERNAL MODULE: ./src/client/common/i18n/useLanguageTranslation.tsx
var useLanguageTranslation = __webpack_require__(32438);
// EXTERNAL MODULE: ./src/client/utils/useGenderTranslation.tsx
var useGenderTranslation = __webpack_require__(5353);
// EXTERNAL MODULE: ./src/client/utils/useCountryTranslation.tsx
var useCountryTranslation = __webpack_require__(67415);
// EXTERNAL MODULE: ./src/client/utils/useNextOfKinRelationshipTranslation.tsx
var useNextOfKinRelationshipTranslation = __webpack_require__(53810);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/ErrorOutline.js
var ErrorOutline = __webpack_require__(11829);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Checkbox/Checkbox.js
var Checkbox = __webpack_require__(91241);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-modal@0.3.9_vyafebljftw2lpwbgyprbkkpkm/node_modules/@elephant-healthcare/mui-modal/dist/module.js
var mui_modal_dist_module = __webpack_require__(27832);
// EXTERNAL MODULE: ./src/ui/index.ts + 7 modules
var ui = __webpack_require__(31630);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var mui_toast_dist = __webpack_require__(28841);
var dist_default = /*#__PURE__*/__webpack_require__.n(mui_toast_dist);
// EXTERNAL MODULE: ./src/client/new/links.ts
var links = __webpack_require__(81222);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(28205);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/PatientDetailsHeader/__generated__/ReissuePinModal.gql.ts


const defaultOptions = {};
const ReissuePinDocument = lib/* gql */.Ps`
    mutation reissuePin($patientUuid: String!) {
  createPin(patientUuid: $patientUuid) {
    pin
  }
}
    `;
function useReissuePinMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(ReissuePinDocument, options);
}

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/PatientDetailsHeader/ReissuePinModal.tsx














const useStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  body: {
    paddingTop: "16px",
    paddingBottom: "0px"
  },
  headerText: {
    fontWeight: "bold"
  },
  headerWrapper: {
    borderBottom: `1px solid ${theme.palette.grey.border}`,
    paddingBottom: "16px"
  },
  headerComponent: {
    paddingBottom: "0",
    background: "white"
  },
  contentWrapper: {
    width: "100%",
    borderBottom: `1px solid ${theme.palette.grey.border}`
  },
  warningBreakout: {
    background: theme.palette.secondary.main
  },
  warningIcon: {
    color: theme.palette.warning.main,
    height: 50,
    width: 50
  },
  confirmationText: {
    display: "flex",
    alignItems: "center",
    color: theme.palette.secondary.contrastText
  },
  question: {
    display: "inline-block",
    minWidth: "250px",
    width: "250px"
  },
  questionsWrapper: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "8px",
    fontFamily: theme.typography.fontFamily
  },
  questionsHeading: {
    marginBottom: "16px"
  }
}));
const CHECKBOX_ID = "reissuepin-confirmation";
const SecurityQuestion = ({ question, answer, classes }) => /* @__PURE__ */ react.createElement("span", null, /* @__PURE__ */ react.createElement("span", {
  className: classes.question
}, question, "? "), answer);
lib/* gql */.Ps`
  mutation reissuePin($patientUuid: String!) {
    createPin(patientUuid: $patientUuid) {
      pin
    }
  }
`;
const ReissuePinModal = ({
  open,
  onClose,
  patient
}) => {
  var _a;
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const [confirmed, setConfirmed] = (0,react.useState)(false);
  const classes = useStyles();
  const navigate = (0,dist/* useNavigate */.s0)();
  const [createPin] = useReissuePinMutation({
    variables: { patientUuid: patient.uuid },
    onCompleted: ({ createPin: { pin } }) => {
      onClose();
      const hasPhone = patient.contactPoints.find(
        (c) => c.system === "phone" && /(personal|shared)/.test(c.ownership)
      );
      if (hasPhone) {
        navigate((0,links/* linkToNewCardsSendPin */.NW)(), {
          state: { phoneNumber: hasPhone.value, pin, patientId: patient.uuid }
        });
      } else {
        navigate((0,links/* linkToNewCardsShowPin */.hG)(), {
          state: { pin, patientId: patient.uuid }
        });
      }
    },
    onError: (e) => dist_default().error(
      formatMessage(
        {
          id: "reissuePinModal.serverError",
          defaultMessage: "There was an issue, please try again later: {message}"
        },
        { message: e.message }
      )
    )
  });
  const phone = ((_a = patient.contactPoints[0]) == null ? void 0 : _a.value) ? patient.contactPoints[0].value : "-";
  return /* @__PURE__ */ react.createElement(ui/* Modal */.u_, {
    open,
    onClose,
    "data-testid": "patientConsentModalContainer"
  }, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalHeader */.xB, {
    className: classes.headerComponent
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    className: classes.headerWrapper
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h5",
    className: classes.headerText
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.reissuepin.title",
    defaultMessage: "Identity Check"
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalBody */.fe, {
    className: classes.body
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    flexDirection: "column",
    className: classes.contentWrapper
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    p: 2,
    display: "flex",
    mb: 2,
    className: classes.warningBreakout
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mr: 2
  }, /* @__PURE__ */ react.createElement(ErrorOutline/* default */.Z, {
    className: classes.warningIcon
  })), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.confirmationText
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.reissuepin.confirm",
    defaultMessage: "Please check patient's identity. If the identity can not be confirmed, do not continue."
  }))), /* @__PURE__ */ react.createElement("div", {
    className: classes.questionsWrapper
  }, /* @__PURE__ */ react.createElement("span", {
    className: classes.questionsHeading
  }, "Security questions:"), /* @__PURE__ */ react.createElement(SecurityQuestion, {
    question: "1. What is your full name",
    answer: patient.fullName,
    classes
  }), /* @__PURE__ */ react.createElement(SecurityQuestion, {
    question: "2. What is your phone number",
    answer: phone,
    classes
  }), /* @__PURE__ */ react.createElement(SecurityQuestion, {
    question: "3. What is your date of birth",
    answer: (0,dayjs/* default */.Z)(patient.dob).format("DD/MM/YYYY"),
    classes
  })), /* @__PURE__ */ react.createElement("label", {
    htmlFor: CHECKBOX_ID,
    "data-testid": "header-reissuepin-checkbox-label"
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mb: 2,
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mr: 2
  }, /* @__PURE__ */ react.createElement(Checkbox/* default */.Z, {
    autoFocus: true,
    color: "primary",
    id: CHECKBOX_ID,
    value: confirmed,
    onChange: (e) => {
      setConfirmed(e.target.checked);
    },
    inputProps: {
      "data-testid": "patientConsentCheckbox"
    },
    "data-testid": "header-reissuepin-checkbox"
  })), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.reissuepin.checkbox",
    defaultMessage: "I confirm the patient's identity"
  })))))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mr: 2
  }, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: onClose,
    "data-testid": "patientConsentCancelBtn"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.reissuepin.cancel",
    defaultMessage: "Cancel"
  }))), /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "primary",
    onClick: () => createPin(),
    disabled: !confirmed,
    "data-testid": "header-reissuepin-confirm"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.reissuepin.confirmationBtn",
    defaultMessage: "Confirm"
  }))));
};

// EXTERNAL MODULE: ./src/client/pages/ReissueCard/links.ts
var ReissueCard_links = __webpack_require__(1961);
// EXTERNAL MODULE: ./src/client/edit/patient/links.ts
var patient_links = __webpack_require__(39397);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+launchdarkly-provider@1.4.4_cn5jcockkrembw54osxy7yvfpi/node_modules/@elephant-healthcare/launchdarkly-provider/dist/module.js
var launchdarkly_provider_dist_module = __webpack_require__(45309);
// EXTERNAL MODULE: ./src/client/common/featureFlags/index.ts
var featureFlags = __webpack_require__(72766);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/PatientDetailsHeader/HeaderInsuranceStatus.tsx
var HeaderInsuranceStatus = __webpack_require__(54598);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/PatientDetailsHeader/PatientDetailsPopover/NA.tsx
const NA = "-";

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/PatientDetailsHeader/PatientDetailsPopover/PopoverInsurance.tsx




function PopoverInsurance(props) {
  const insuranceProvider = (0,HeaderInsuranceStatus/* getCurrentInsuranceProviderName */.lu)(props);
  if (!insuranceProvider) {
    return /* @__PURE__ */ react.createElement("span", null, NA);
  }
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "inline-flex",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "inline",
    component: "span",
    mr: 1
  }, insuranceProvider), /* @__PURE__ */ react.createElement(HeaderInsuranceStatus/* InsuranceValidityChip */.ji, {
    ...props
  }));
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/styled.js
var styled = __webpack_require__(69525);
// EXTERNAL MODULE: ./src/client/patient-pay/PaymentStatusChip.tsx
var PaymentStatusChip = __webpack_require__(73892);
// EXTERNAL MODULE: ./src/__generated__/base.gql.ts
var base_gql = __webpack_require__(3047);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/PatientDetailsHeader/PatientDetailsPopover/PaymentDetails.tsx






const PaymentDetailsWrapper = (0,styled/* default */.Z)("div")(({ theme }) => ({
  display: "inline-flex",
  gap: theme.spacing(1),
  alignItems: "center"
}));
const PaymentDetails = ({ status, onClick }) => /* @__PURE__ */ react.createElement(PaymentDetailsWrapper, null, /* @__PURE__ */ react.createElement(PaymentStatusChip/* default */.Z, {
  status
}), status === base_gql/* PaymentStatus.Unpaid */.bG.Unpaid && /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
  onClick
}, /* @__PURE__ */ react.createElement(message/* default */.Z, {
  id: "patientDetails.popover.takePayment",
  defaultMessage: "Take Payment"
})));

// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(79226);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/PatientDetailsHeader/PatientDetailsPopover/__generated__/RegistrationPaymentModal.gql.ts


const RegistrationPaymentModal_gql_defaultOptions = {};
const RecordPaymentInPatientHeaderDocument = lib/* gql */.Ps`
    mutation RecordPaymentInPatientHeader($input: RecordPaymentInput!) {
  recordPayment(input: $input) {
    id
  }
}
    `;
function useRecordPaymentInPatientHeaderMutation(baseOptions) {
  const options = { ...RegistrationPaymentModal_gql_defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(RecordPaymentInPatientHeaderDocument, options);
}

// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@7.31.1_react@18.1.0/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(21235);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.9/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(85961);
// EXTERNAL MODULE: ./node_modules/.pnpm/@hookform+resolvers@2.9.11_react-hook-form@7.31.1/node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(1793);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.16.1/node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(13875);
// EXTERNAL MODULE: ./src/client/forms/hookForm/index.ts
var hookForm = __webpack_require__(86347);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+react-hook-form-input@0.1.7_sjfm3rrfwwtsx5okgtvvldeidu/node_modules/@elephant-healthcare/react-hook-form-input/dist/module.js
var react_hook_form_input_dist_module = __webpack_require__(29054);
// EXTERNAL MODULE: ./src/client/observability/uxAnalytics/index.ts + 5 modules
var uxAnalytics = __webpack_require__(62463);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/PatientDetailsHeader/PatientDetailsPopover/RegistrationPaymentModal.tsx















lib/* gql */.Ps`
  mutation RecordPaymentInPatientHeader($input: RecordPaymentInput!) {
    recordPayment(input: $input) {
      id
    }
  }
`;
const ModalBody = (0,styled/* default */.Z)(mui_modal_dist_module/* ModalBody */.fe)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(2),
  paddingBlock: 0
}));
const DatePicker = (0,styled/* default */.Z)(hookForm/* RHFDatePicker */.C5)({
  flex: 1,
  minWidth: 200
});
const ReceiptNumberField = (0,styled/* default */.Z)(hookForm/* RHFTextField */.au)({
  flex: 1,
  minWidth: 300
});
const formSchema = es.object({
  paymentDate: es.date().required(),
  receiptNumber: es.string()
});
var TracingSpans = /* @__PURE__ */ ((TracingSpans2) => {
  TracingSpans2["ROOT"] = "patientDetailsHeaderRegistrationPaymentModal";
  TracingSpans2["SUBMIT"] = "patientDetailsHeaderRegistrationPaymentModal.submit";
  return TracingSpans2;
})(TracingSpans || {});
const TracingEvents = {
  ["patientDetailsHeaderRegistrationPaymentModal.submit" /* SUBMIT */]: {
    SUCCESS: `${"patientDetailsHeaderRegistrationPaymentModal.submit" /* SUBMIT */}.success`,
    FAILURE: `${"patientDetailsHeaderRegistrationPaymentModal.submit" /* SUBMIT */}.failure`
  }
};
const RegistrationPaymentModal = ({ open, onClose, patientId }) => {
  const { startSpan, endSpan, addEventToSpan } = (0,uxAnalytics/* useTracing */.kz)();
  (0,react.useEffect)(() => {
    if (open) {
      startSpan("patientDetailsHeaderRegistrationPaymentModal" /* ROOT */, { root: true });
    } else {
      endSpan("patientDetailsHeaderRegistrationPaymentModal" /* ROOT */);
    }
  }, [open]);
  const apolloClient = (0,useApolloClient/* useApolloClient */.x)();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const [savePayment, { loading }] = useRecordPaymentInPatientHeaderMutation({
    onCompleted: () => {
      addEventToSpan(TracingEvents["patientDetailsHeaderRegistrationPaymentModal.submit" /* SUBMIT */].SUCCESS);
      endSpan("patientDetailsHeaderRegistrationPaymentModal.submit" /* SUBMIT */);
      apolloClient.cache.modify({
        id: `Patient:${patientId}`,
        fields: {
          registrationPayment: () => {
            return { status: base_gql/* PaymentStatus.Paid */.bG.Paid };
          }
        }
      });
      onClose();
    },
    onError: (error) => {
      addEventToSpan(TracingEvents["patientDetailsHeaderRegistrationPaymentModal.submit" /* SUBMIT */].FAILURE);
      endSpan("patientDetailsHeaderRegistrationPaymentModal.submit" /* SUBMIT */);
      dist_default().error(
        formatMessage(
          {
            id: "patientDetails.paymentModal.erro",
            defaultMessage: "There was an error: {error}"
          },
          { error: error.message }
        )
      );
    }
  });
  const formMethods = (0,index_esm/* useForm */.cI)({
    resolver: (0,yup/* yupResolver */.X)(formSchema),
    reValidateMode: "onBlur",
    defaultValues: {
      paymentDate: new Date()
    }
  });
  return /* @__PURE__ */ react.createElement(mui_modal_dist_module/* Modal */.u_, {
    open,
    onClose,
    title: "Take Registration Payment"
  }, /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...formMethods
  }, /* @__PURE__ */ react.createElement("form", {
    onSubmit: formMethods.handleSubmit(
      ({ paymentDate, receiptNumber }) => {
        startSpan("patientDetailsHeaderRegistrationPaymentModal.submit" /* SUBMIT */);
        savePayment({
          variables: {
            input: {
              paidOn: (0,format/* default */.Z)(paymentDate, "yyyy-MM-dd"),
              patientId,
              receiptNumber
            }
          }
        });
      }
    )
  }, /* @__PURE__ */ react.createElement(ModalBody, null, /* @__PURE__ */ react.createElement(DatePicker, {
    name: "paymentDate",
    label: formatMessage({
      id: "patientDetails.paymentModal.date",
      defaultMessage: "Payment Date"
    }),
    hideHelper: true
  }), /* @__PURE__ */ react.createElement(ReceiptNumberField, {
    name: "receiptNumber",
    label: formatMessage({
      id: "patientDetails.paymentModal.receiptNumber",
      defaultMessage: "Receipt number"
    }),
    hideHelper: true
  })), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, null, /* @__PURE__ */ react.createElement(react_hook_form_input_dist_module/* SubmitButton */.Mm, {
    loading
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patientDetails.paymentModal.submit",
    defaultMessage: "Submit"
  }))))));
};

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/PatientDetailsHeader/PatientDetailsPopover/index.tsx
























const PatientDetailsPopover_useStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  paper: { borderRadius: "12px" },
  heading: {
    color: theme.palette.secondary.main
  },
  popoverWrapper: {
    padding: "16px",
    background: theme.palette.common.white,
    [theme.breakpoints.up("sm")]: {
      minWidth: "550px"
    }
  },
  buttonsWrapper: {
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
      flexDirection: "column"
    }
  },
  button: {
    minWidth: "160px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "16px",
      width: "300px"
    }
  },
  detailsWrapper: {
    display: "flex",
    flexDirection: "column",
    borderBottom: `1px solid ${theme.palette.grey.border}`,
    marginBottom: "16px",
    fontFamily: theme.typography.fontFamily,
    paddingBottom: "8px"
  },
  detailsColumn: {
    display: "flex",
    marginBottom: "8px",
    alignItems: "center"
  },
  columnHeading: {
    display: "inline-block",
    fontWeight: "bold",
    width: "100px"
  }
}));
const DetailsColumn = ({ heading, detail, hide = false }) => {
  const styles = PatientDetailsPopover_useStyles();
  if (hide)
    return null;
  return /* @__PURE__ */ react.createElement("span", {
    className: styles.detailsColumn
  }, /* @__PURE__ */ react.createElement("span", {
    className: styles.columnHeading
  }, heading, ": "), detail || NA);
};
function PatientDetailsPopover({
  patient,
  cardId,
  open,
  anchorEl,
  onClose
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const patientPayEnabled = (0,launchdarkly_provider_dist_module/* useFeatureFlag */.ye)(featureFlags/* featureFlags.patientPay */.VH.patientPay);
  const territory = (0,useTerritory/* default */.Z)();
  const navigate = (0,dist/* useNavigate */.s0)();
  const styles = PatientDetailsPopover_useStyles();
  const { translateLanguageCode } = (0,useLanguageTranslation/* usePatientLanguageTranslation */.u5)();
  const { translateGenderCode } = (0,useGenderTranslation/* default */.Z)();
  const { translateCountryCode } = (0,useCountryTranslation/* default */.Z)();
  const { translateNextOfKinRelationshipCode } = (0,useNextOfKinRelationshipTranslation/* default */.Z)();
  const [reissuePinModalOpen, setReissuePinModalOpen] = (0,react.useState)(false);
  const [paymentModalOpen, setPaymentModalOpen] = (0,react.useState)(false);
  const { person, insurance, currentVisit } = patient;
  const address = person.addresses[0];
  const formatAddress = address ? `${address.state}, ${address.subCounty}, ${address.street}` : NA;
  const formatGender = person.gender ? translateGenderCode(person.gender) : NA;
  const contactPoint = person.contactPoints[0];
  const formatPhone = (contactPoint == null ? void 0 : contactPoint.ownership) ? `${contactPoint.ownership.charAt(0).toUpperCase() + contactPoint.ownership.slice(1)}, ${contactPoint.value}` : NA;
  const formatInsurance = /* @__PURE__ */ react.createElement(PopoverInsurance, {
    insurance,
    currentVisit
  });
  const formatInsuranceNo = (insurance == null ? void 0 : insurance.insuranceNumber) || NA;
  const nextOfKin = person.contacts[0];
  const nextOfKinName = [(_a = nextOfKin == null ? void 0 : nextOfKin.name) == null ? void 0 : _a.firstname, (_b = nextOfKin == null ? void 0 : nextOfKin.name) == null ? void 0 : _b.lastname].filter(Boolean).join(" ").trim();
  const nextOfKinPhone = (_d = (_c = nextOfKin == null ? void 0 : nextOfKin.contactPoints) == null ? void 0 : _c.find(
    (cp) => cp.system === "phone"
  )) == null ? void 0 : _d.value;
  const nextOfKinRelationship = (_f = (_e = nextOfKin == null ? void 0 : nextOfKin.contactPoints) == null ? void 0 : _e.find(
    (cp) => cp.system === "other"
  )) == null ? void 0 : _f.value;
  const formatNextOfKin = nextOfKin ? [
    nextOfKinName,
    nextOfKinPhone,
    nextOfKinRelationship ? translateNextOfKinRelationshipCode(nextOfKinRelationship) : void 0
  ].filter(Boolean).join(", ") : NA;
  const formatLanguage = ((_g = person == null ? void 0 : person.languages[0]) == null ? void 0 : _g.locale) ? translateLanguageCode((_h = person == null ? void 0 : person.languages[0]) == null ? void 0 : _h.locale) : NA;
  const formatNationality = person.nationality ? translateCountryCode(person.nationality) : NA;
  const isPakistan = territory === constants/* TERRITORY.PAKISTAN */.jQ.PAKISTAN;
  return /* @__PURE__ */ react.createElement(Popover/* default */.ZP, {
    disableScrollLock: true,
    classes: { paper: styles.paper },
    open,
    anchorEl,
    onClose,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    }
  }, /* @__PURE__ */ react.createElement("div", {
    className: styles.popoverWrapper
  }, /* @__PURE__ */ react.createElement("div", {
    className: styles.detailsWrapper
  }, /* @__PURE__ */ react.createElement(DetailsColumn, {
    heading: formatMessage({
      id: "patientDetails.dateOfBirth",
      defaultMessage: "Date of Birth"
    }),
    detail: (0,dayjs/* default */.Z)(person.dob).format("DD/MM/YYYY")
  }), /* @__PURE__ */ react.createElement(DetailsColumn, {
    heading: formatMessage({
      id: "patientDetails.elephantId",
      defaultMessage: "Elephant ID"
    }),
    detail: (0,getCardId/* formatCardId */.E)(cardId)
  }), /* @__PURE__ */ react.createElement(DetailsColumn, {
    heading: formatMessage({
      id: "patientDetails.sex",
      defaultMessage: "Sex"
    }),
    detail: formatGender
  }), /* @__PURE__ */ react.createElement(DetailsColumn, {
    heading: formatMessage({
      id: "patientDetails.address",
      defaultMessage: "Address"
    }),
    detail: formatAddress
  }), /* @__PURE__ */ react.createElement(DetailsColumn, {
    heading: formatMessage({
      id: "patientDetails.phone",
      defaultMessage: "Phone"
    }),
    detail: formatPhone
  }), /* @__PURE__ */ react.createElement(DetailsColumn, {
    heading: formatMessage({
      id: "patientDetails.nationality",
      defaultMessage: "Nationality"
    }),
    detail: formatNationality,
    hide: isPakistan
  }), /* @__PURE__ */ react.createElement(DetailsColumn, {
    heading: formatMessage({
      id: "patientDetails.language",
      defaultMessage: "Language"
    }),
    detail: formatLanguage,
    hide: isPakistan
  }), /* @__PURE__ */ react.createElement(DetailsColumn, {
    heading: formatMessage({
      id: "patientDetails.insurance",
      defaultMessage: "Insurance"
    }),
    detail: formatInsurance,
    hide: isPakistan
  }), /* @__PURE__ */ react.createElement(DetailsColumn, {
    heading: formatMessage({
      id: "patientDetails.insuranceNo",
      defaultMessage: "Insurance No"
    }),
    detail: formatInsuranceNo,
    hide: isPakistan
  }), /* @__PURE__ */ react.createElement(DetailsColumn, {
    heading: formatMessage({
      id: "patientDetails.nextOfKin",
      defaultMessage: "Next of Kin"
    }),
    detail: formatNextOfKin
  }), /* @__PURE__ */ react.createElement(DetailsColumn, {
    heading: formatMessage({
      id: "patientDetails.regisrationPayment",
      defaultMessage: "Registration Fee"
    }),
    detail: /* @__PURE__ */ react.createElement(PaymentDetails, {
      status: patient.registrationPayment.status,
      onClick: () => setPaymentModalOpen(true)
    }),
    hide: !patientPayEnabled
  })), /* @__PURE__ */ react.createElement("div", {
    className: styles.buttonsWrapper
  }, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    className: styles.button,
    onClick: () => navigate((0,patient_links/* linkToEditPatient */.U)(patient.uuid)),
    startIcon: /* @__PURE__ */ react.createElement(mui_icon_dist_module.EditIcon, null),
    "data-testid": "popover-edit-patient"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patientDetails.editPatientButton.text",
    defaultMessage: "Edit Patient"
  })), /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    className: styles.button,
    onClick: () => navigate((0,ReissueCard_links/* linkToCardReissue */.F)(), { state: patient }),
    startIcon: /* @__PURE__ */ react.createElement(mui_icon_dist_module.QrCodeIcon, null),
    "data-testid": "popover-reissue-card"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patientDetails.reissueCardButton.text",
    defaultMessage: "Re-Issue Card"
  })), /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    className: styles.button,
    onClick: () => setReissuePinModalOpen(true),
    startIcon: /* @__PURE__ */ react.createElement(mui_icon_dist_module.ReissuePinIcon, null),
    "data-testid": "popover-reissue-pin"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patientDetails.reissuePinButton.text",
    defaultMessage: "Re-Issue PIN"
  })))), /* @__PURE__ */ react.createElement(ReissuePinModal, {
    onClose: () => {
      setReissuePinModalOpen(false);
    },
    open: reissuePinModalOpen,
    patient: {
      uuid: patient.uuid,
      contactPoints: (_i = patient.person.contactPoints) != null ? _i : [],
      fullName: (_j = patient.person.name.fullname) != null ? _j : "",
      dob: patient.person.dob
    }
  }), /* @__PURE__ */ react.createElement(RegistrationPaymentModal, {
    open: paymentModalOpen,
    onClose: () => setPaymentModalOpen(false),
    patientId: patient.uuid
  }));
}
/* harmony default export */ const PatientDetailsHeader_PatientDetailsPopover = (PatientDetailsPopover);

// EXTERNAL MODULE: ./src/client/utils/helpers.ts
var helpers = __webpack_require__(9921);
// EXTERNAL MODULE: ./src/client/components/Layout/Header/index.tsx + 1 modules
var Header = __webpack_require__(14187);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/__generated__/queries.gql.ts
var queries_gql = __webpack_require__(94152);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.16.1/node_modules/date-fns/esm/parse/index.js + 1 modules
var parse = __webpack_require__(61705);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/PatientDetailsHeader/index.tsx


















const PatientDetailsHeader_useStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  headerWrapper: {
    display: "flex",
    flexDirection: "row",
    cursor: "pointer",
    "&:focus": {
      outline: "0"
    }
  },
  ageLabel: {
    marginRight: theme.spacing(0.5)
  },
  headerText: {
    color: theme.palette.common.white,
    textAlign: "end",
    "&:first-child": {
      marginBottom: theme.spacing(0.5)
    },
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(3)
    }
  },
  heading: {
    color: theme.palette.secondary.main
  },
  line2: {
    "& .MuiChip-root": {
      cursor: "pointer"
    },
    "& > *": {
      margin: `0 ${theme.spacing(1)}px`
    },
    "& > *:last-child": {
      marginRight: 0
    }
  },
  chevronWrapper: {
    display: "flex",
    alignItems: "center",
    marginLeft: "8px"
  },
  chevron: {
    transitionProperty: "transform",
    transitionTimingFunction: "ease-out",
    transitionDuration: theme.transitions.duration.shorter.toString()
  },
  rotateChevron: {
    transform: "rotate(180deg)"
  }
}));
const PatientHeaderCenterContent = ({ patientUuid }) => /* @__PURE__ */ react.createElement(Box/* default */.Z, {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  sx: { width: "100%" }
}, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
  mr: 1
}, /* @__PURE__ */ react.createElement(TriageStatusDropdown/* default */.Z, null)), /* @__PURE__ */ react.createElement(QueueDropdown/* default */.Z, {
  patientId: patientUuid
}));
const PatientInfo = ({
  patientData
}) => {
  var _a, _b;
  const styles = PatientDetailsHeader_useStyles();
  const [anchorEl, setAnchorEl] = (0,react.useState)(null);
  if (!((_b = (_a = patientData == null ? void 0 : patientData.patientByCardId) == null ? void 0 : _a.patient) == null ? void 0 : _b.person)) {
    return /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "patient.patientheader.loading",
      defaultMessage: "Loading..."
    });
  }
  const { patient } = patientData.patientByCardId;
  const { person } = patient;
  const { firstname, middlename, lastname } = person.name;
  const dobDate = person.dob ? (0,parse/* default */.Z)(person.dob, "yyyy-MM-dd", new Date()) : void 0;
  const age = dobDate && (0,helpers/* dateYearsMonths */.B)(dobDate);
  const name = [firstname, middlename, lastname].join(" ");
  const popoverOpen = Boolean(anchorEl);
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("div", {
    className: styles.headerWrapper,
    "data-testid": "header-details",
    onClick: (event) => {
      setAnchorEl(event.currentTarget);
    },
    role: "button",
    tabIndex: 0,
    "aria-hidden": "true"
  }, /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h5",
    className: styles.headerText
  }, name), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h6",
    className: styles.headerText
  }, dobDate && age && /* @__PURE__ */ react.createElement("span", null, /* @__PURE__ */ react.createElement("span", {
    className: styles.heading
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.generalSection.age.label",
    defaultMessage: "Age"
  }), ": "), age), /* @__PURE__ */ react.createElement(HeaderInsuranceStatus/* default */.ZP, {
    insurance: patient.insurance,
    currentVisit: patient.currentVisit
  }))), /* @__PURE__ */ react.createElement("div", {
    className: styles.chevronWrapper
  }, /* @__PURE__ */ react.createElement(mui_icon_dist_module.ChevronUpIconCircle, {
    className: classnames_default()(styles.chevron, {
      [styles.rotateChevron]: !popoverOpen
    })
  }))), /* @__PURE__ */ react.createElement(PatientDetailsHeader_PatientDetailsPopover, {
    patient,
    cardId: (0,getCardId/* getCardId */.s)(patientData),
    open: popoverOpen,
    anchorEl,
    onClose: () => setAnchorEl(false)
  }));
};
const PatientDetailsHeader = (props) => {
  const query = (0,useQuerystring/* default */.Z)();
  const searchWholeTerritory = (0,launchdarkly_provider_dist_module/* useFeatureFlag */.ye)(
    featureFlags/* featureFlags.patient.territoryDataSharing */.VH.patient.territoryDataSharing
  );
  const uuid = props.patientUuid || query.patientUuid || query.patient;
  const [findPatientQuery, { data: patientData }] = (0,queries_gql/* usePatientDetailsLazyQuery */.eB)({
    variables: { uuid, searchWholeTerritory },
    fetchPolicy: "cache-and-network"
  });
  (0,react.useEffect)(() => {
    if (uuid) {
      findPatientQuery();
    }
  }, [findPatientQuery, uuid]);
  return /* @__PURE__ */ react.createElement(Header/* default */.Z, {
    centerContent: /* @__PURE__ */ react.createElement(PatientHeaderCenterContent, {
      patientUuid: uuid
    }),
    rightContent: /* @__PURE__ */ react.createElement(PatientInfo, {
      patientData
    })
  });
};
/* harmony default export */ const PatientOverview_PatientDetailsHeader = (PatientDetailsHeader);


/***/ }),

/***/ 80368:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": () => (/* binding */ PatientOverviewTabOption)
/* harmony export */ });
var PatientOverviewTabOption = /* @__PURE__ */ ((PatientOverviewTabOption2) => {
  PatientOverviewTabOption2["History"] = "history";
  PatientOverviewTabOption2["Invoices"] = "invoices";
  return PatientOverviewTabOption2;
})(PatientOverviewTabOption || {});


/***/ }),

/***/ 98256:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CP": () => (/* binding */ useAncEncountersQuery),
/* harmony export */   "Gq": () => (/* binding */ AncEncountersDocument),
/* harmony export */   "KI": () => (/* binding */ useAncEncountersLazyQuery),
/* harmony export */   "cH": () => (/* binding */ useOngoingInpatientVisitsQuery),
/* harmony export */   "lX": () => (/* binding */ OngoingInpatientVisitsDocument),
/* harmony export */   "s": () => (/* binding */ useInpatientHistoryQuery)
/* harmony export */ });
/* unused harmony exports InpatientHistoryDocument, useInpatientHistoryLazyQuery, useOngoingInpatientVisitsLazyQuery */
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24520);
/* harmony import */ var _inpatient_generated_queries_gql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93300);
/* harmony import */ var _clinical_engine_anc_encounter_generated_graphql_gql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3152);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41552);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90322);




const defaultOptions = {};
const InpatientHistoryDocument = _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps`
    query InpatientHistory($input: PastInpatientVisitsInput!) {
  pastInpatientVisits(input: $input) {
    items {
      _id
      admissionEvent {
        _id
        type
        created
        notes
        performer {
          _id
          name
        }
        ...CareEventDiagnosis
      }
      detentionEvent {
        _id
        type
        created
        notes
        performer {
          _id
          name
        }
        ...CareEventDiagnosis
      }
      dischargeEvent {
        _id
        type
        created
        notes
        performer {
          _id
          name
        }
        ...CareEventDiagnosis
      }
      meta {
        created
      }
    }
    hasMore
    limit
    offset
    total
  }
}
    ${_inpatient_generated_queries_gql__WEBPACK_IMPORTED_MODULE_0__/* .CareEventDiagnosisFragmentDoc */ .Lg}`;
function useInpatientHistoryQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a(InpatientHistoryDocument, options);
}
function useInpatientHistoryLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(InpatientHistoryDocument, options);
}
const OngoingInpatientVisitsDocument = _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps`
    query OngoingInpatientVisits($input: OngoingInpatientVisitsInput!) {
  ongoingInpatientVisits(input: $input) {
    items {
      _id
    }
  }
}
    `;
function useOngoingInpatientVisitsQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a(OngoingInpatientVisitsDocument, options);
}
function useOngoingInpatientVisitsLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(OngoingInpatientVisitsDocument, options);
}
const AncEncountersDocument = _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps`
    query AncEncounters($input: QueryAncEncountersInput!) {
  ancEncounters(input: $input) {
    encounters {
      ...AncEncounterFragment
    }
  }
}
    ${_clinical_engine_anc_encounter_generated_graphql_gql__WEBPACK_IMPORTED_MODULE_1__/* .AncEncounterFragmentFragmentDoc */ .N}`;
function useAncEncountersQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a(AncEncountersDocument, options);
}
function useAncEncountersLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useLazyQuery */ .t(AncEncountersDocument, options);
}


/***/ }),

/***/ 68315:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ Tabs_History)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/client/components/Loading/Loading.tsx
var Loading = __webpack_require__(56250);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(90322);
// EXTERNAL MODULE: ./src/client/inpatient/activityCard/CurrentInpatientCard.tsx
var CurrentInpatientCard = __webpack_require__(70592);
// EXTERNAL MODULE: ./src/client/investigations/InvestigationActivitiesProvider.tsx
var InvestigationActivitiesProvider = __webpack_require__(85855);
// EXTERNAL MODULE: ./src/client/utils/getCardId.ts
var getCardId = __webpack_require__(47274);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/queries.ts
var queries = __webpack_require__(28405);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./node_modules/.pnpm/dayjs@1.8.36/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(4548);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./src/client/inpatient/activityCard/InpatientCard.tsx
var InpatientCard = __webpack_require__(10470);
// EXTERNAL MODULE: ./src/client/investigations/InvestigationActivityOutcome.tsx + 1 modules
var InvestigationActivityOutcome = __webpack_require__(60831);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(948);
// EXTERNAL MODULE: ./node_modules/.pnpm/ramda@0.27.0/node_modules/ramda/es/partition.js + 6 modules
var partition = __webpack_require__(81371);
// EXTERNAL MODULE: ./src/client/investigations/InvestigationActivityCard.tsx + 1 modules
var InvestigationActivityCard = __webpack_require__(34726);
// EXTERNAL MODULE: ./src/client/investigations/DynamicInvestigationResults/InvestigationResults.tsx
var InvestigationResults = __webpack_require__(854);
// EXTERNAL MODULE: ./src/client/utils/constants.ts
var constants = __webpack_require__(20589);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/History/Sections/Investigations.jsx






const systolicNames = [constants/* BLOOD_PRESSURE_SYSTOLIC */.YL, "BP - Systolic"];
function mapTestResult(data, systolic) {
  var _a;
  const { name, displayName, value, unit } = data;
  if ([constants/* BLOOD_PRESSURE_DIASTOLIC */.iP, "BP - Diastolic"].includes(name)) {
    return [{ title: "Blood Pressure" }, `${systolic}/${value}`];
  }
  if (((_a = data.name) == null ? void 0 : _a.toLowerCase()) === "notes") {
    return [{ title: "Notes" }, /* @__PURE__ */ react.createElement("pre", null, value)];
  }
  return [{ title: displayName || name }, `${value} ${unit || ""}`];
}
const Investigation = ({ testResult }) => {
  var _a;
  if (!((_a = testResult == null ? void 0 : testResult.results) == null ? void 0 : _a.length))
    return null;
  const { created } = testResult.meta;
  return testResult.results.map((result) => {
    var _a2;
    if (!((_a2 = result.result) == null ? void 0 : _a2.length))
      return null;
    const [systolicResults, nonSystolicResults] = (0,partition/* default */.Z)(
      (item) => systolicNames.includes(item.name),
      result.result
    );
    const lastSystolic = systolicResults[systolicResults.length - 1];
    const items = nonSystolicResults.map(
      (item) => mapTestResult(item, lastSystolic == null ? void 0 : lastSystolic.value)
    );
    return /* @__PURE__ */ react.createElement(InvestigationActivityCard/* default */.Z, {
      title: result.name,
      fulfilledDate: created,
      fulfiller: " ",
      key: `${testResult.uuid}-${result.investigation}`
    }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
      container: true,
      spacing: 1,
      justifyContent: "space-between"
    }, /* @__PURE__ */ react.createElement(InvestigationResults/* default */.Z, {
      items
    })));
  });
};
/* harmony default export */ const Investigations = (Investigation);

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/History/types.ts
function isInvestigationActivity(cardEntity) {
  return cardEntity.__typename === "InvestigationActivity";
}
function isVisit(cardEntity) {
  return cardEntity.__typename === "Visit";
}
function isLegacyTestResult(cardEntity) {
  return cardEntity.__typename === "TestResult";
}
function isConsultation(cardEntity) {
  return cardEntity.__typename === "Consultation";
}
function isAncEncounter(cardEntity) {
  return cardEntity.__typename === "AncEncounter";
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-style@0.2.18_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-style/dist/module.js
var dist_module = __webpack_require__(10353);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-card@0.2.10_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@elephant-healthcare/mui-card/dist/module.js
var mui_card_dist_module = __webpack_require__(21534);
// EXTERNAL MODULE: ./src/ui/Typography/MultiLineTypography.tsx
var MultiLineTypography = __webpack_require__(31790);
// EXTERNAL MODULE: ./src/client/components/FormattedDate/FormattedDate.tsx
var FormattedDate = __webpack_require__(20058);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/History/Sections/Diagnoses.tsx







const useStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  observationContainer: {
    display: "flex",
    flexDirection: "column"
  },
  observationDetail: {
    color: theme.palette.text.discreet
  },
  diagnosisWrapper: {
    marginTop: 10
  },
  marginRight: {
    marginRight: 30
  }
}));
const Diagnoses = ({
  diagnoses,
  diseases,
  problem,
  presentingComplaint,
  plan,
  deliveredOn,
  deliveredBy,
  locationName
}) => {
  const classes = useStyles();
  const hasExtraDetails = !!problem || !!plan || !!presentingComplaint;
  return /* @__PURE__ */ react.createElement(mui_card_dist_module/* Card */.Zb, {
    "data-testid": "patient.history.diagnosis.consultation",
    color: mui_card_dist_module/* CardColors.CONSULTATION */.L3.CONSULTATION,
    expandable: hasExtraDetails,
    style: { marginBottom: 0 }
  }, /* @__PURE__ */ react.createElement(mui_card_dist_module/* CardBody */.eW, null, /* @__PURE__ */ react.createElement(mui_card_dist_module/* CardSummary */.Jy, null, /* @__PURE__ */ react.createElement(mui_card_dist_module/* CardSubtitle */._R, {
    color: mui_card_dist_module/* CardColors.CONSULTATION */.L3.CONSULTATION,
    gutterBottom: true
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.history.diagnosis.consultation.title",
    defaultMessage: "Consultation"
  })), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    flexDirection: "column"
  }, diseases.map((disease) => /* @__PURE__ */ react.createElement(mui_card_dist_module/* CardTitle */.ll, {
    key: disease.uuid
  }, disease.displayName)), diagnoses.map((diagnosis) => /* @__PURE__ */ react.createElement(mui_card_dist_module/* CardTitle */.ll, {
    key: diagnosis.uuid
  }, diagnosis.codification.name)))), hasExtraDetails && /* @__PURE__ */ react.createElement(mui_card_dist_module/* CardDetails */.u0, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mb: 1
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    className: classes.observationContainer
  }, problem && /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2",
    className: classes.observationDetail
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.history.diagnosis.problem",
    defaultMessage: "Problem"
  })), /* @__PURE__ */ react.createElement(MultiLineTypography/* default */.Z, {
    variant: "body2"
  }, problem)), presentingComplaint && /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12,
    className: classes.diagnosisWrapper
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2",
    className: classes.observationDetail
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.history.diagnosis.presentingComplaint",
    defaultMessage: "Presenting complaint"
  })), /* @__PURE__ */ react.createElement(MultiLineTypography/* default */.Z, {
    variant: "body2"
  }, presentingComplaint)), plan && /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12,
    className: classes.diagnosisWrapper
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2",
    className: classes.observationDetail
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.history.diagnosis.plan",
    defaultMessage: "Plan"
  })), /* @__PURE__ */ react.createElement(MultiLineTypography/* default */.Z, {
    variant: "body2"
  }, plan)))))), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    mt: 1
  }, /* @__PURE__ */ react.createElement(mui_card_dist_module/* CardFooterItem */.Tq, {
    className: classes.marginRight
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.history.diagnosis.deliveredOn",
    defaultMessage: "Delivered:"
  })), " ", /* @__PURE__ */ react.createElement(FormattedDate/* default */.Z, {
    value: deliveredOn
  })), /* @__PURE__ */ react.createElement(mui_card_dist_module/* CardFooterItem */.Tq, {
    className: classes.marginRight
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.history.diagnosis.deliveredBy",
    defaultMessage: "By:"
  })), " ", deliveredBy), locationName && /* @__PURE__ */ react.createElement(mui_card_dist_module/* CardFooterItem */.Tq, null, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.history.diagnosis.location",
    defaultMessage: "Location:"
  })), ` ${locationName}`)));
};
/* harmony default export */ const Sections_Diagnoses = (Diagnoses);

// EXTERNAL MODULE: ./src/client/components/Prescriptions/PrescriptionCard.tsx + 6 modules
var PrescriptionCard = __webpack_require__(41635);
// EXTERNAL MODULE: ./src/client/common/featureFlags/index.ts
var featureFlags = __webpack_require__(72766);
// EXTERNAL MODULE: ./src/client/printing/useThermalPrintDivAsImage.ts
var useThermalPrintDivAsImage = __webpack_require__(73837);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var dist = __webpack_require__(28841);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/client/prescriptions/PrescriptionInstructions.tsx
var PrescriptionInstructions = __webpack_require__(57081);
// EXTERNAL MODULE: ./src/client/printing/ThermalPrintableArea.tsx
var ThermalPrintableArea = __webpack_require__(87502);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var mui_button_dist_module = __webpack_require__(2550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-icon@0.3.15_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-icon/dist/module.js
var mui_icon_dist_module = __webpack_require__(46828);
// EXTERNAL MODULE: ./src/client/common/i18n/prescriptions.ts
var i18n_prescriptions = __webpack_require__(59028);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/History/Sections/DiagnosesWithPrescriptions.tsx












const DiagnosesWithPrescriptions = ({
  diagnoses,
  diseases,
  problem,
  plan,
  deliveredBy,
  deliveredOn,
  facilityName,
  locationName,
  patientName,
  prescriptions = [],
  presentingComplaint,
  printPerConsultationFlag = false
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { print, printableRef, error } = (0,useThermalPrintDivAsImage/* default */.Z)();
  (0,react.useEffect)(() => {
    if (!error) {
      return;
    }
    dist_default().error(
      formatMessage(
        {
          id: "investigationActivity.outcome.printer.error",
          defaultMessage: "A printer error occured: {message}"
        },
        { message: error.message }
      )
    );
  }, [error, formatMessage]);
  const prescriptionInstructions = prescriptions.map((prescription) => {
    var _a, _b, _c;
    return {
      id: prescription.uuid,
      title: (0,i18n_prescriptions/* getPrescriptionLabel */.OK)(prescription, formatMessage),
      prescribedAt: deliveredOn,
      notes: prescription.note,
      dose: {
        asNeeded: (_a = prescription.dose) == null ? void 0 : _a.asNeeded,
        frequency: (_b = prescription.dose) == null ? void 0 : _b.rateQuantity,
        duration: (_c = prescription.dose) == null ? void 0 : _c.durationQuantity
      }
    };
  });
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Sections_Diagnoses, {
    diagnoses,
    diseases,
    problem,
    presentingComplaint,
    plan,
    deliveredOn,
    deliveredBy,
    locationName
  }), prescriptions.map((prescription) => /* @__PURE__ */ react.createElement(PrescriptionCard/* PrescriptionCard */.d, {
    key: prescription.uuid,
    prescription,
    prescribedBy: deliveredBy,
    prescribedAt: deliveredOn,
    locationName
  })), prescriptions.length > 0 && printPerConsultationFlag && /* @__PURE__ */ react.createElement(featureFlags/* FeatureFlagGuard */.s3, {
    flagKey: featureFlags/* featureFlags.patient.history.thermalPrintMedicationInstructions */.VH.patient.history.thermalPrintMedicationInstructions,
    render: () => prescriptionInstructions.length > 0 && /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
      color: "secondary",
      onClick: print,
      startIcon: /* @__PURE__ */ react.createElement(mui_icon_dist_module.PrinterIcon, null)
    }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "patient.history.printMedicationInstructions",
      defaultMessage: "Print Medication Instructions"
    })), /* @__PURE__ */ react.createElement(ThermalPrintableArea/* default */.Z, {
      printableRef
    }, /* @__PURE__ */ react.createElement(PrescriptionInstructions/* default */.Z, {
      patientName,
      facilityName,
      instructions: prescriptionInstructions
    })))
  }));
};
/* harmony default export */ const Sections_DiagnosesWithPrescriptions = (DiagnosesWithPrescriptions);

// EXTERNAL MODULE: ./node_modules/.pnpm/ramda@0.27.0/node_modules/ramda/es/omit.js
var omit = __webpack_require__(99129);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-to-print@2.12.6_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/react-to-print/lib/index.js
var react_to_print_lib = __webpack_require__(64300);
var lib_default = /*#__PURE__*/__webpack_require__.n(react_to_print_lib);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/index.js + 1 modules
var react_intl_lib = __webpack_require__(11313);
// EXTERNAL MODULE: ./src/client/utils/helpers.ts
var helpers = __webpack_require__(9921);
// EXTERNAL MODULE: ./src/client/components/Dose/StyledDosageString.tsx
var StyledDosageString = __webpack_require__(98605);
// EXTERNAL MODULE: ./src/client/investigations/DynamicInvestigationResults/index.ts + 3 modules
var DynamicInvestigationResults = __webpack_require__(74100);
// EXTERNAL MODULE: ./src/client/forms/hookForm/index.ts
var hookForm = __webpack_require__(86347);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-modal@0.3.9_vyafebljftw2lpwbgyprbkkpkm/node_modules/@elephant-healthcare/mui-modal/dist/module.js
var mui_modal_dist_module = __webpack_require__(27832);
// EXTERNAL MODULE: ./src/ui/index.ts + 7 modules
var ui = __webpack_require__(31630);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@7.31.1_react@18.1.0/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(21235);
// EXTERNAL MODULE: ./src/style/images/warningIcon.svg
var warningIcon = __webpack_require__(71813);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/History/DownloadReportModal.tsx










var ReportOption = /* @__PURE__ */ ((ReportOption2) => {
  ReportOption2["WithoutHistory"] = "WITHOUT_HISTORY";
  ReportOption2["WithHistory"] = "WITH_HISTORY";
  return ReportOption2;
})(ReportOption || {});
const DownloadReportModal_useStyles = (0,dist_module/* makeStyles */.Z)(() => ({
  rowCenter: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  warningIcon: {
    width: "50px",
    marginRight: "15px"
  },
  modalBody: {
    overflow: "auto"
  }
}));
const DownloadReportModal = ({
  isOpen,
  onClose,
  onSubmit
}) => {
  const [isSubmitting, setSubmitting] = (0,react.useState)(false);
  const [reportOption, setReportOption] = (0,react.useState)(
    "WITHOUT_HISTORY" /* WithoutHistory */
  );
  const onFormSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      onSubmit(reportOption);
    } catch (err) {
      console.warn("On submit should be infallible, but it failed", err);
    } finally {
      setSubmitting(false);
    }
  };
  const classes = DownloadReportModal_useStyles();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const formMethods = (0,index_esm/* useForm */.cI)();
  return /* @__PURE__ */ react.createElement(ui/* Modal */.u_, {
    open: isOpen,
    onClose,
    "data-testid": "patient-history-download-report-modal"
  }, /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...formMethods
  }, /* @__PURE__ */ react.createElement("form", {
    onSubmit: onFormSubmit
  }, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalHeader */.xB, {
    bgcolor: "background.paper"
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    className: classes.rowCenter,
    display: "flex",
    flexDirection: "row"
  }, /* @__PURE__ */ react.createElement("img", {
    className: classes.warningIcon,
    src: warningIcon,
    alt: "warning"
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h4"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.history.downloadReport.modal.title",
    defaultMessage: "Doctor's Report"
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalBody */.fe, {
    className: classes.modalBody
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    px: 2
  }, /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    flexDirection: "row"
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "subtitle2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.history.downloadReport.modal.description",
    defaultMessage: "Kindly select an option"
  }))), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFRadioField */.ov, {
    required: true,
    "data-testid": "patient-history-download-report-options",
    name: "reportOptions",
    value: reportOption,
    onChange: (e) => setReportOption(e.target.value),
    options: [
      {
        value: "WITHOUT_HISTORY" /* WithoutHistory */,
        label: formatMessage({
          id: "patient.history.downloadReport.modal.option.withoutHistory",
          defaultMessage: "Without History (For insurance claims)"
        })
      },
      {
        value: "WITH_HISTORY" /* WithHistory */,
        label: formatMessage({
          id: "patient.history.downloadReport.modal.option.withHistory",
          defaultMessage: "With History (For patient transfers and referrals)"
        })
      }
    ]
  }))))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, null, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: onClose
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.history.downloadReport.modal.cancel",
    defaultMessage: "Cancel"
  })), /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    type: "submit",
    loading: isSubmitting,
    "data-testid": "patient-history-download-report-submit-button"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.history.downloadReport.modal.submit",
    defaultMessage: "Download"
  }))))));
};
/* harmony default export */ const History_DownloadReportModal = (DownloadReportModal);

// EXTERNAL MODULE: ./src/client/antenatal-care/constants.ts
var antenatal_care_constants = __webpack_require__(17234);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/History/PrintableDoctorReport.tsx












const PrintableDoctorReport_useStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  containerWrapper: {
    display: "none"
  },
  printWrapper: {
    margin: "5mm"
  },
  box: {
    margin: "0 15px",
    padding: "10px 0"
  },
  subTitle: {
    fontSize: 16
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    marginBottom: theme.spacing(1)
  },
  resultsBox: {
    width: "50%",
    alignSelf: "flex-end"
  },
  title: {
    width: "70%",
    margin: 0
  },
  cardIdWrapper: {
    width: "30%",
    textAlign: "right"
  },
  prescriptionDetails: {
    width: "60%",
    margin: 0
  },
  prescriber: {
    width: "40%",
    alignSelf: "flex-end"
  },
  patientInfo: {
    margin: 0,
    marginBottom: theme.spacing(1)
  },
  patientWrapper: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3)
  },
  section: {
    paddingBottom: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.grey.borderLight}`
  },
  clinic: {
    marginBottom: theme.spacing(1)
  },
  sectionTitle: {
    marginBottom: theme.spacing(1)
  },
  history: {
    whiteSpace: "pre-wrap"
  },
  footer: {
    marginTop: theme.spacing(4)
  },
  footerWrapper: {
    float: "right"
  }
}));
function findClinicianName(historicEvents) {
  var _a, _b, _c, _d;
  for (const historicEvent of historicEvents) {
    if (isConsultation(historicEvent)) {
      const clinician = ((_a = historicEvent.prescriptions) == null ? void 0 : _a.length) > 0 ? ((_b = historicEvent.prescriptions[0].dispensation) == null ? void 0 : _b.dispensedBy) || historicEvent.deliveredBy : historicEvent.deliveredBy;
      if (clinician) {
        return [clinician.person.firstname, clinician.person.lastname].filter(Boolean).join(" ");
      }
    }
    if (isVisit(historicEvent)) {
      const name = (_d = (_c = historicEvent.admissionEvent) == null ? void 0 : _c.performer) == null ? void 0 : _d.name;
      if (name) {
        return name;
      }
    }
  }
  return void 0;
}
class ComponentToPrint extends react.Component {
  render() {
    const {
      classes,
      consultations,
      date,
      patient,
      cardId,
      clinicName,
      reportOption
    } = this.props;
    const firstInvestigationIndex = consultations.findIndex(
      isInvestigationActivity
    );
    const clinicianName = findClinicianName(consultations);
    const firstConsultation = consultations[0];
    return /* @__PURE__ */ react.createElement("div", {
      className: classes.printWrapper
    }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
      className: classes.box
    }, /* @__PURE__ */ react.createElement("div", {
      className: classes.container
    }, /* @__PURE__ */ react.createElement("h1", {
      className: classes.title
    }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "patient.history.report.doctorsReport",
      defaultMessage: "Doctor's Report"
    }), " - ", isVisit(firstConsultation) ? /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "eclaims.print.inpatient",
      defaultMessage: "Inpatient"
    }) : /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "eclaims.print.outpatient",
      defaultMessage: "Outpatient"
    })), /* @__PURE__ */ react.createElement("div", {
      className: classes.cardIdWrapper
    }, /* @__PURE__ */ react.createElement("span", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "patient.history.report.id",
      defaultMessage: "ID:"
    }), cardId))), /* @__PURE__ */ react.createElement("h2", {
      className: classes.clinic
    }, clinicName), /* @__PURE__ */ react.createElement("span", {
      className: classes.subTitle
    }, date), /* @__PURE__ */ react.createElement("div", {
      className: classes.patientWrapper
    }, /* @__PURE__ */ react.createElement("p", {
      className: classes.patientInfo
    }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "patient.history.report.name",
      defaultMessage: "Name:"
    })), patient.name), /* @__PURE__ */ react.createElement("p", {
      className: classes.patientInfo
    }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "patient.history.report.age",
      defaultMessage: "Age:"
    })), ` ${(0,helpers/* dateYearsMonths */.B)(patient.dob)}`), /* @__PURE__ */ react.createElement("p", {
      className: classes.patientInfo
    }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "patient.history.report.gender",
      defaultMessage: "Gender:"
    })), patient.gender === "m" ? " Male" : " Female"), patient.phoneNumber && /* @__PURE__ */ react.createElement("p", {
      className: classes.patientInfo
    }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "patient.history.report.phone",
      defaultMessage: "Phone:"
    })), ` ${patient.phoneNumber}`), isVisit(firstConsultation) && /* @__PURE__ */ react.createElement(react.Fragment, null, firstConsultation.detentionEvent && /* @__PURE__ */ react.createElement("p", {
      className: classes.patientInfo,
      "data-testid": "printable-summary-detention-timestamp"
    }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "eclaims.print.inpatient.detention",
      defaultMessage: "Detained On: "
    })), /* @__PURE__ */ react.createElement(react_intl_lib/* FormattedDate */.Ji, {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      value: firstConsultation.detentionEvent.created
    })), firstConsultation.admissionEvent && /* @__PURE__ */ react.createElement("p", {
      className: classes.patientInfo,
      "data-testid": "printable-summary-admission-timestamp"
    }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "eclaims.print.inpatient.admission",
      defaultMessage: "Admitted On: "
    })), /* @__PURE__ */ react.createElement(react_intl_lib/* FormattedDate */.Ji, {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      value: firstConsultation.admissionEvent.created
    })), firstConsultation.dischargeEvent && /* @__PURE__ */ react.createElement("p", {
      className: classes.patientInfo,
      "data-testid": "printable-summary-discharge-timestamp"
    }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "eclaims.print.inpatient.discharge",
      defaultMessage: "Discharged On: "
    })), /* @__PURE__ */ react.createElement(react_intl_lib/* FormattedDate */.Ji, {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      value: firstConsultation.dischargeEvent.created
    })))), reportOption === ReportOption.WithHistory && /* @__PURE__ */ react.createElement("div", {
      className: classes.section
    }, /* @__PURE__ */ react.createElement("h2", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "patient.history.report.problem",
      defaultMessage: "History and examination"
    })), consultations == null ? void 0 : consultations.map(
      (consultation) => isConsultation(consultation) && !!consultation.problem ? /* @__PURE__ */ react.createElement("div", {
        key: `${consultation.uuid}-problem`,
        className: classes.history
      }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
        variant: "body2"
      }, consultation.problem)) : null
    )), /* @__PURE__ */ react.createElement("div", null, consultations.map((consultation, index) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
      const investigationFulfiller = (_a = consultation.outcome) == null ? void 0 : _a.performer;
      const investigationFulfilledDate = (_e = (_c = (_b = consultation.outcome) == null ? void 0 : _b.meta) == null ? void 0 : _c.created) != null ? _e : (_d = consultation.meta) == null ? void 0 : _d.created;
      const key = isInvestigationActivity(consultation) && (consultation == null ? void 0 : consultation._id) || isConsultation(consultation) && (consultation == null ? void 0 : consultation.uuid) || isAncEncounter(consultation) && (consultation == null ? void 0 : consultation.id);
      return /* @__PURE__ */ react.createElement("div", {
        key: `${key}-root`
      }, isInvestigationActivity(consultation) && /* @__PURE__ */ react.createElement(react.Fragment, null, firstInvestigationIndex === index && /* @__PURE__ */ react.createElement("h2", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
        id: "patient.history.report.investigations",
        defaultMessage: "Investigations"
      })), /* @__PURE__ */ react.createElement("div", {
        className: classes.sectionTitle
      }, /* @__PURE__ */ react.createElement("strong", {
        className: classes.subTitle
      }, (_f = consultation.catalogueItem) == null ? void 0 : _f.title)), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
        className: classes.container
      }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
        className: classes.resultsBox
      }, /* @__PURE__ */ react.createElement(DynamicInvestigationResults/* default */.Z, {
        property: (0,omit/* default */.Z)(
          ["meta"],
          (_g = consultation.outcome) != null ? _g : consultation.request
        ),
        print: true
      })), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
        className: classes.resultsBox,
        textAlign: "right"
      }, ((_h = consultation.outcome) == null ? void 0 : _h.performer) ? /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
        variant: "body2"
      }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
        id: "patient.history.report.requestedBy",
        defaultMessage: "Requested by:"
      })), (investigationFulfiller == null ? void 0 : investigationFulfiller.name) ? ` ${investigationFulfiller.name}${investigationFulfilledDate ? ", " : ""}` : "", investigationFulfilledDate ? /* @__PURE__ */ react.createElement(react_intl_lib/* FormattedDate */.Ji, {
        value: investigationFulfilledDate
      }) : null) : null))), isConsultation(consultation) && /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("div", {
        className: classes.section
      }, /* @__PURE__ */ react.createElement("h2", {
        className: classes.sectionTitle
      }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
        id: "patient.history.report.diagnosis",
        defaultMessage: "Diagnosis"
      })), (_i = consultation == null ? void 0 : consultation.diseases) == null ? void 0 : _i.map(
        (disease) => /* @__PURE__ */ react.createElement("div", {
          key: disease.uuid
        }, /* @__PURE__ */ react.createElement("strong", {
          className: classes.subTitle
        }, disease.displayName))
      ), (_j = consultation == null ? void 0 : consultation.diagnoses) == null ? void 0 : _j.map(
        (diagnosis) => /* @__PURE__ */ react.createElement("div", {
          key: diagnosis.uuid
        }, /* @__PURE__ */ react.createElement("strong", {
          className: classes.subTitle
        }, diagnosis.codification.name))
      )), /* @__PURE__ */ react.createElement("div", {
        className: classes.section
      }, /* @__PURE__ */ react.createElement("h2", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
        id: "patient.history.report.prescription",
        defaultMessage: "Prescription"
      })), (_k = consultation == null ? void 0 : consultation.prescriptions) == null ? void 0 : _k.map(
        (prescription) => {
          var _a2, _b2, _c2, _d2, _e2;
          return /* @__PURE__ */ react.createElement("div", {
            key: prescription.uuid
          }, /* @__PURE__ */ react.createElement("div", {
            className: classes.sectionTitle
          }, /* @__PURE__ */ react.createElement("strong", {
            className: classes.subTitle
          }, prescription.codification)), /* @__PURE__ */ react.createElement("div", {
            className: classes.container
          }, /* @__PURE__ */ react.createElement("div", {
            className: classes.prescriptionDetails
          }, /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
            variant: "body2",
            component: "p"
          }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
            id: "patient.history.report.datePrescribed",
            defaultMessage: "Date prescribed:"
          })), "\xA0", /* @__PURE__ */ react.createElement(react_intl_lib/* FormattedDate */.Ji, {
            value: consultation.meta.created
          }))), /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
            variant: "body2",
            component: "p"
          }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
            id: "patient.history.report.singleDosage",
            defaultMessage: "Single dosage:"
          }), "\xA0"), prescription.dose.doseQuantity ? `${prescription.dose.doseQuantity.value} ${prescription.dose.doseQuantity.unit}` : null))), /* @__PURE__ */ react.createElement("div", {
            className: classes.prescriber
          }, /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
            variant: "body2",
            component: "p"
          }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
            id: "patient.history.report.prescribedBy",
            defaultMessage: "Prescribed by:"
          })), "\xA0", `${((_a2 = consultation.deliveredBy) == null ? void 0 : _a2.person.firstname) || ""} ${((_b2 = consultation.deliveredBy) == null ? void 0 : _b2.person.lastname) || ""}`)), /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
            variant: "body2",
            component: "p"
          }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
            id: "patient.history.report.dosesToDispense",
            defaultMessage: "Doses to dispense:"
          })), "\xA0", (0,StyledDosageString/* dosageCount */.t)(
            (_c2 = prescription == null ? void 0 : prescription.dose) == null ? void 0 : _c2.rateQuantity,
            (_d2 = prescription == null ? void 0 : prescription.dose) == null ? void 0 : _d2.durationQuantity,
            (_e2 = prescription == null ? void 0 : prescription.dose) == null ? void 0 : _e2.doseQuantity
          ))))));
        }
      ))), isAncEncounter(consultation) && /* @__PURE__ */ react.createElement("div", {
        className: classes.section,
        key: consultation.id
      }, /* @__PURE__ */ react.createElement("h2", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
        id: "patient.history.report.anc",
        defaultMessage: "Antenatal Care"
      })), Object.entries(consultation).filter(([k]) => antenatal_care_constants/* fieldFormatters */.lR[k] != null).map(([k, value]) => {
        const field = antenatal_care_constants/* fieldFormatters */.lR[k];
        return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
          key: `${consultation.id}-${k}`,
          my: 2
        }, /* @__PURE__ */ react.createElement("strong", {
          className: classes.subTitle
        }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
          ...field.label
        })), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
          variant: "body2",
          component: "p"
        }, field.format(value)));
      }), (consultation == null ? void 0 : consultation.prescriptions.length) && /* @__PURE__ */ react.createElement("div", {
        className: classes.section
      }, /* @__PURE__ */ react.createElement("h2", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
        id: "patient.history.report.prescription",
        defaultMessage: "Prescription"
      })), (_l = consultation == null ? void 0 : consultation.prescriptions) == null ? void 0 : _l.map((prescription) => {
        var _a2, _b2;
        return /* @__PURE__ */ react.createElement("div", {
          key: prescription.id
        }, /* @__PURE__ */ react.createElement("div", {
          className: classes.sectionTitle
        }, /* @__PURE__ */ react.createElement("strong", {
          className: classes.subTitle
        }, prescription.clinicalProduct.title)), /* @__PURE__ */ react.createElement("div", {
          className: classes.container
        }, /* @__PURE__ */ react.createElement("div", {
          className: classes.prescriptionDetails
        }, /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
          variant: "body2",
          component: "p"
        }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
          id: "patient.history.report.anc.datePrescribed",
          defaultMessage: "Date prescribed:"
        })), "\xA0", /* @__PURE__ */ react.createElement(react_intl_lib/* FormattedDate */.Ji, {
          value: consultation.meta.created
        }))), /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
          variant: "body2",
          component: "p"
        }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
          id: "patient.history.report.anc.singleDosage",
          defaultMessage: "Single dosage:"
        }), "\xA0"), prescription.dosage ? `${prescription.dosage.value} ${prescription.dosage.unit}` : null))), /* @__PURE__ */ react.createElement("div", {
          className: classes.prescriber
        }, /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
          variant: "body2",
          component: "p"
        }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
          id: "patient.history.report.anc.prescribedBy",
          defaultMessage: "Prescribed by:"
        })), "\xA0", `${((_a2 = prescription.prescriber) == null ? void 0 : _a2.person.firstname) || ""} ${((_b2 = prescription.prescriber) == null ? void 0 : _b2.person.lastname) || ""}`)), /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
          variant: "body2",
          component: "p"
        }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
          id: "patient.history.report.anc.dosesToDispense",
          defaultMessage: "Doses to dispense:"
        })), "\xA0", (0,StyledDosageString/* dosageCount */.t)(
          prescription == null ? void 0 : prescription.rate,
          prescription == null ? void 0 : prescription.frequency,
          prescription == null ? void 0 : prescription.dosage
        ))))));
      }))));
    })), reportOption === ReportOption.WithHistory && /* @__PURE__ */ react.createElement("div", {
      className: classes.section
    }, /* @__PURE__ */ react.createElement("h2", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "patient.history.report.plan",
      defaultMessage: "Plan"
    })), consultations.map(
      (consultation) => isConsultation(consultation) && !!consultation.plan ? /* @__PURE__ */ react.createElement("div", {
        key: `${consultation.uuid}-plan`,
        className: classes.history
      }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
        variant: "body2"
      }, consultation.plan)) : null
    )), /* @__PURE__ */ react.createElement("div", {
      className: classes.footer
    }, /* @__PURE__ */ react.createElement("div", {
      className: classes.footerWrapper
    }, /* @__PURE__ */ react.createElement("h3", null, /* @__PURE__ */ react.createElement("strong", null, clinicianName)), /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "patient.history.report.digitallyVerified",
      defaultMessage: "Digitally Verified"
    })))));
  }
}
class ReactToPrintRemoteTrigger extends (lib_default()) {
  render() {
    return /* @__PURE__ */ react.createElement("div", null);
  }
}
const PrintableDoctorReport = (props) => {
  const componentRef = (0,react.useRef)();
  const reportRef = (0,react.useRef)();
  const classes = PrintableDoctorReport_useStyles();
  const { onAfterPrint, ...restProps } = props;
  (0,react.useEffect)(() => {
    var _a;
    (_a = reportRef.current) == null ? void 0 : _a.handleClick();
  }, []);
  return /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(ReactToPrintRemoteTrigger, {
    ref: reportRef,
    content: () => componentRef.current,
    pageStyle: "@page{ size: a4; } @media print{  }",
    onAfterPrint
  }), /* @__PURE__ */ react.createElement("div", {
    className: classes.containerWrapper
  }, /* @__PURE__ */ react.createElement(ComponentToPrint, {
    ref: componentRef,
    classes,
    ...restProps
  })));
};
/* harmony default export */ const History_PrintableDoctorReport = (PrintableDoctorReport);

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/History/DownloadReportButton.tsx






const useDownloadReportStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  downloadReport: {
    fontWeight: 700,
    color: theme.palette.secondary.main,
    cursor: "pointer",
    border: 0,
    padding: 0,
    outline: "none",
    background: "none",
    "&:focus,&:active,&:hover": {
      textDecoration: "underline",
      color: theme.palette.primary.main
    }
  }
}));
const DownloadReportButton = ({
  date,
  historicEvents,
  patient,
  clinicName
}) => {
  const [shouldPrint, setShouldPrint] = (0,react.useState)(false);
  const [openModal, setOpenModal] = (0,react.useState)(false);
  const [reportOption, setReportOption] = (0,react.useState)(null);
  const classes = useDownloadReportStyles();
  const detailedReportFF = (0,featureFlags/* useFeatureFlag */.ye)(
    featureFlags/* featureFlags.patient.history.detailedReport */.VH.patient.history.detailedReport
  );
  const onClickDownloadReport = () => {
    if (detailedReportFF) {
      setOpenModal(true);
    } else {
      setShouldPrint(true);
    }
  };
  const onSubmitReportOption = (opt) => {
    setReportOption(opt);
    setShouldPrint(true);
    setOpenModal(false);
  };
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(History_DownloadReportModal, {
    isOpen: !!openModal,
    onClose: () => setOpenModal(false),
    onSubmit: (opt) => onSubmitReportOption(opt)
  }), /* @__PURE__ */ react.createElement("button", {
    className: classes.downloadReport,
    onClick: () => onClickDownloadReport(),
    type: "button"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.history.downloadReport",
    defaultMessage: "Download Report"
  })), shouldPrint && /* @__PURE__ */ react.createElement(History_PrintableDoctorReport, {
    date: date.replaceAll(" ", ""),
    cardId: patient.cardId,
    clinicName,
    consultations: historicEvents,
    patient,
    reportOption,
    onAfterPrint: () => {
      setShouldPrint(false);
    }
  }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/styled.js
var styled = __webpack_require__(69525);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+launchdarkly-provider@1.4.4_cn5jcockkrembw54osxy7yvfpi/node_modules/@elephant-healthcare/launchdarkly-provider/dist/module.js
var launchdarkly_provider_dist_module = __webpack_require__(45309);
// EXTERNAL MODULE: ./src/client/antenatal-care/AncEncounterCard.tsx
var AncEncounterCard = __webpack_require__(40876);
// EXTERNAL MODULE: ./src/client/antenatal-care/Prescription/AncPrescriptionCard.tsx
var AncPrescriptionCard = __webpack_require__(22594);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/History/HistoricEventsForDate.tsx




















const ActionButtonsWrapper = (0,styled/* default */.Z)("div")({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between",
  "& > div:last-child": {
    marginLeft: "auto"
  }
});
const DateHeader = (0,styled/* default */.Z)("span")(({ theme }) => ({
  display: "inline-block",
  fontSize: "14px",
  fontWeight: 700,
  background: theme.palette.grey.borderLight,
  padding: "5px 8px",
  borderRadius: "3px",
  width: "max-content"
}));
const Container = (0,styled/* default */.Z)("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3)
}));
const PrintMedicationInstructionsButton = ({
  print,
  printableRef,
  patient,
  facilityName,
  prescriptionInstructions
}) => /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
  color: "secondary",
  onClick: print,
  startIcon: /* @__PURE__ */ react.createElement(mui_icon_dist_module.PrinterIcon, null)
}, /* @__PURE__ */ react.createElement(message/* default */.Z, {
  id: "patient.history.printMedicationInstructions",
  defaultMessage: "Print Medication Instructions"
})), /* @__PURE__ */ react.createElement(ThermalPrintableArea/* default */.Z, {
  printableRef
}, /* @__PURE__ */ react.createElement(PrescriptionInstructions/* default */.Z, {
  patientName: patient.name,
  facilityName,
  instructions: prescriptionInstructions
})));
const HistoricEventsForDate = ({
  date,
  historicEvents,
  facilityName,
  patient
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { print, printableRef, error } = (0,useThermalPrintDivAsImage/* default */.Z)();
  const printPerConsultationFlag = (0,launchdarkly_provider_dist_module/* useFeatureFlag */.ye)(
    featureFlags/* featureFlags.patient.history.printPerConsultation */.VH.patient.history.printPerConsultation
  );
  (0,react.useEffect)(() => {
    if (!error) {
      return;
    }
    dist_default().error(
      formatMessage(
        {
          id: "investigationActivity.outcome.printer.error",
          defaultMessage: "A printer error occured: {message}"
        },
        { message: error.message }
      )
    );
  }, [error, formatMessage]);
  const opdPrescriptionInstructions = historicEvents.filter((event) => isConsultation(event)).flatMap((event) => {
    return event.prescriptions.map((prescription) => {
      var _a, _b, _c;
      return {
        id: prescription.uuid,
        title: (0,i18n_prescriptions/* getPrescriptionLabel */.OK)(prescription, formatMessage),
        prescribedAt: new Date(event.meta.created),
        notes: prescription.note,
        dose: {
          asNeeded: (_a = prescription.dose) == null ? void 0 : _a.asNeeded,
          frequency: (_b = prescription.dose) == null ? void 0 : _b.rateQuantity,
          duration: (_c = prescription.dose) == null ? void 0 : _c.durationQuantity
        }
      };
    });
  });
  const ancPrescriptionInstructions = historicEvents.filter((event) => isAncEncounter(event) && event.prescriptions.length).flatMap((event) => {
    return event.prescriptions.map((prescription) => ({
      id: prescription.id,
      title: prescription.clinicalProduct.title,
      prescribedAt: new Date(event.meta.created),
      notes: prescription.note,
      dose: {
        asNeeded: prescription.asRequired,
        frequency: prescription.rate,
        duration: prescription.frequency
      }
    }));
  });
  const prescriptionInstructions = opdPrescriptionInstructions.concat(
    ancPrescriptionInstructions
  );
  return /* @__PURE__ */ react.createElement(Container, null, /* @__PURE__ */ react.createElement(DateHeader, null, date, printPerConsultationFlag && /* @__PURE__ */ react.createElement(react.Fragment, null, "\u2002\u2002", /* @__PURE__ */ react.createElement(DownloadReportButton, {
    date,
    historicEvents,
    patient,
    clinicName: facilityName
  }))), historicEvents.map((historicEvent) => {
    var _a, _b, _c, _d, _e;
    if (isAncEncounter(historicEvent)) {
      return /* @__PURE__ */ react.createElement(Container, {
        key: historicEvent.id
      }, /* @__PURE__ */ react.createElement(AncEncounterCard/* default */.Z, {
        encounter: historicEvent
      }), !!((_a = historicEvent == null ? void 0 : historicEvent.prescriptions) == null ? void 0 : _a.length) && historicEvent.prescriptions.map((p) => /* @__PURE__ */ react.createElement(AncPrescriptionCard/* AncPrescriptionCard */.j, {
        key: p.id,
        prescription: p
      })), printPerConsultationFlag && /* @__PURE__ */ react.createElement(ActionButtonsWrapper, null, /* @__PURE__ */ react.createElement(featureFlags/* FeatureFlagGuard */.s3, {
        flagKey: featureFlags/* featureFlags.patient.history.thermalPrintMedicationInstructions */.VH.patient.history.thermalPrintMedicationInstructions,
        render: () => ancPrescriptionInstructions.length > 0 && /* @__PURE__ */ react.createElement(PrintMedicationInstructionsButton, {
          print,
          printableRef,
          patient,
          facilityName,
          prescriptionInstructions: ancPrescriptionInstructions
        })
      })));
    }
    if (isInvestigationActivity(historicEvent)) {
      return /* @__PURE__ */ react.createElement(InvestigationActivityOutcome/* default */.Z, {
        key: historicEvent._id,
        investigation: historicEvent,
        subtitle: formatMessage({
          id: "investigationActivity.outcome.header",
          defaultMessage: "Investigation"
        }),
        patientUuid: patient == null ? void 0 : patient.uuid
      });
    }
    if (isLegacyTestResult(historicEvent)) {
      return /* @__PURE__ */ react.createElement(Investigations, {
        key: historicEvent._id,
        testResult: historicEvent
      });
    }
    if (isVisit(historicEvent)) {
      const { admissionEvent, detentionEvent, dischargeEvent } = historicEvent;
      return /* @__PURE__ */ react.createElement(InpatientCard/* default */.ZP, {
        key: historicEvent._id,
        patientUuid: patient == null ? void 0 : patient.uuid,
        visitId: historicEvent._id,
        admissionEvent,
        detentionEvent,
        dischargeEvent,
        "data-testid": "patient-details-inpatient-visit"
      });
    }
    const deliveredBy = [
      (_c = (_b = historicEvent.deliveredBy) == null ? void 0 : _b.person) == null ? void 0 : _c.firstname,
      (_e = (_d = historicEvent.deliveredBy) == null ? void 0 : _d.person) == null ? void 0 : _e.lastname
    ].join(" ");
    return /* @__PURE__ */ react.createElement(Sections_DiagnosesWithPrescriptions, {
      key: historicEvent.uuid,
      diagnoses: historicEvent.diagnoses,
      diseases: historicEvent.diseases,
      problem: historicEvent.problem,
      presentingComplaint: historicEvent.presentingComplaint,
      plan: historicEvent.plan,
      deliveredBy,
      deliveredOn: new Date(historicEvent.meta.created),
      facilityName,
      locationName: historicEvent.location.name,
      prescriptions: historicEvent.prescriptions,
      patientName: patient.name,
      printPerConsultationFlag
    });
  }), !printPerConsultationFlag && /* @__PURE__ */ react.createElement(ActionButtonsWrapper, null, /* @__PURE__ */ react.createElement(featureFlags/* FeatureFlagGuard */.s3, {
    flagKey: featureFlags/* featureFlags.patient.history.thermalPrintMedicationInstructions */.VH.patient.history.thermalPrintMedicationInstructions,
    render: () => prescriptionInstructions.length > 0 && /* @__PURE__ */ react.createElement(PrintMedicationInstructionsButton, {
      print,
      printableRef,
      patient,
      facilityName,
      prescriptionInstructions
    })
  }), /* @__PURE__ */ react.createElement(DownloadReportButton, {
    date,
    historicEvents,
    patient,
    clinicName: facilityName
  })));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/dayjs@1.8.36/node_modules/dayjs/plugin/customParseFormat.js
var customParseFormat = __webpack_require__(97851);
var customParseFormat_default = /*#__PURE__*/__webpack_require__.n(customParseFormat);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/History/HistoricEventTimeline.tsx






dayjs_min_default().extend((customParseFormat_default()));
const sortGroupedHistoricEvents = (groupedCardEntities) => Object.keys(groupedCardEntities).sort((a, b) => {
  var _a, _b;
  const dateA = new Date((_a = groupedCardEntities[a][0].meta) == null ? void 0 : _a.created);
  const dateB = new Date((_b = groupedCardEntities[b][0].meta) == null ? void 0 : _b.created);
  return dateB.getTime() - dateA.getTime();
});
const DATE_FORMAT = "DD / MM / YYYY";
const HistoricEventTimeline = ({
  historicEvents,
  ...restProps
}) => {
  if (historicEvents.length < 1) {
    return /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
      variant: "body1"
    }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "patient.history.consultationEmpty",
      defaultMessage: "Consultation History Empty"
    })));
  }
  const eventsGroupedByDate = historicEvents.reduce(
    (acc, consultation) => {
      var _a;
      const formattedDate = dayjs_min_default()((_a = consultation.meta) == null ? void 0 : _a.created).format(
        DATE_FORMAT
      );
      if (!Array.isArray(acc[formattedDate])) {
        acc[formattedDate] = [];
      }
      acc[formattedDate].push(consultation);
      return acc;
    },
    {}
  );
  const eventsGroupedByDateSortedByDate = sortGroupedHistoricEvents(eventsGroupedByDate);
  return /* @__PURE__ */ react.createElement(react.Fragment, null, eventsGroupedByDateSortedByDate.map((dateStr) => /* @__PURE__ */ react.createElement(HistoricEventsForDate, {
    key: dateStr,
    date: dateStr,
    historicEvents: eventsGroupedByDate[dateStr],
    ...restProps
  })));
};

// EXTERNAL MODULE: ./src/client/components/ErrorPage/index.tsx
var ErrorPage = __webpack_require__(64493);
// EXTERNAL MODULE: ./src/client/inpatient/queries.ts
var inpatient_queries = __webpack_require__(22251);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/History/__generated__/History.gql.ts
var History_gql = __webpack_require__(98256);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.16.1/node_modules/date-fns/esm/parse/index.js + 1 modules
var parse = __webpack_require__(61705);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/__generated__/queries.gql.ts
var queries_gql = __webpack_require__(94152);
// EXTERNAL MODULE: ./src/client/clinical-engine/anc-encounter/graphql.ts
var graphql = __webpack_require__(31798);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/History/History.tsx



















lib/* gql */.Ps`
  query InpatientHistory($input: PastInpatientVisitsInput!) {
    pastInpatientVisits(input: $input) {
      items {
        _id
        admissionEvent {
          _id
          type
          created
          notes
          performer {
            _id
            name
          }
          ...CareEventDiagnosis
        }
        detentionEvent {
          _id
          type
          created
          notes
          performer {
            _id
            name
          }
          ...CareEventDiagnosis
        }
        dischargeEvent {
          _id
          type
          created
          notes
          performer {
            _id
            name
          }
          ...CareEventDiagnosis
        }
        meta {
          created
        }
      }
      hasMore
      limit
      offset
      total
    }
  }
  ${inpatient_queries/* inpatientGraphql.fragments.careEventDiagnosisFragment */.MF.fragments.careEventDiagnosisFragment}
`;
lib/* gql */.Ps`
  query OngoingInpatientVisits($input: OngoingInpatientVisitsInput!) {
    ongoingInpatientVisits(input: $input) {
      items {
        _id
      }
    }
  }
`;
lib/* gql */.Ps`
  query AncEncounters($input: QueryAncEncountersInput!) {
    ancEncounters(input: $input) {
      encounters {
        ...AncEncounterFragment
      }
    }
  }
  ${graphql/* default.fragment.ancEncounter */.Z.fragment.ancEncounter}
`;
const History_Container = (0,styled/* default */.Z)("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(6)
}));
const History = ({ consultations, patientUuid }) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const territoryDataSharingFeatureEnabled = (0,launchdarkly_provider_dist_module/* useFeatureFlag */.ye)(
    featureFlags/* featureFlags.patient.territoryDataSharing */.VH.patient.territoryDataSharing
  );
  const {
    data: patientData,
    loading: patientDataLoading,
    error: patientDataError
  } = (0,queries_gql/* usePatientDetailsQuery */.GJ)({
    variables: {
      uuid: patientUuid,
      searchWholeTerritory: territoryDataSharingFeatureEnabled
    }
  });
  const patient = (_a = patientData == null ? void 0 : patientData.patientByCardId) == null ? void 0 : _a.patient;
  const [
    getClinic,
    { data: clinicData, called: clinicCalled, error: clinicDataError }
  ] = (0,useLazyQuery/* useLazyQuery */.t)(queries/* CLINIC_QUERY */.aX);
  (0,react.useEffect)(() => {
    if (!clinicCalled && (patient == null ? void 0 : patient.clinic)) {
      getClinic({
        variables: {
          clinicId: patient.clinic
        }
      });
    }
  }, [clinicCalled, getClinic, patient == null ? void 0 : patient.clinic]);
  const patientCardId = (0,getCardId/* getCardId */.s)(patientData);
  const { data: inpatientData } = (0,History_gql/* useInpatientHistoryQuery */.s)({
    variables: { input: { patientUuid, offset: 0, limit: 20 } }
  });
  const inpatientVisits = (_c = (_b = inpatientData == null ? void 0 : inpatientData.pastInpatientVisits) == null ? void 0 : _b.items) != null ? _c : [];
  const { data: ongoingInpatientData } = (0,History_gql/* useOngoingInpatientVisitsQuery */.cH)({
    variables: { input: { patientUuid, offset: 0, limit: 20 } }
  });
  const ongoingAdmissions = (_e = (_d = ongoingInpatientData == null ? void 0 : ongoingInpatientData.ongoingInpatientVisits) == null ? void 0 : _d.items) != null ? _e : [];
  const { data: ancEncountersData } = (0,History_gql/* useAncEncountersQuery */.CP)({
    variables: {
      input: {
        params: {
          patientId: patientUuid,
          searchWholeTerritory: territoryDataSharingFeatureEnabled
        }
      }
    }
  });
  const encounters = ((_g = (_f = ancEncountersData == null ? void 0 : ancEncountersData.ancEncounters) == null ? void 0 : _f.encounters) != null ? _g : []).map((encounter) => ({
    ...encounter,
    meta: { created: encounter.createdAt }
  }));
  const { data: investigationsData } = (0,InvestigationActivitiesProvider/* useInvestigationActivitiesContext */.DD)();
  const investigations = (_i = (_h = investigationsData == null ? void 0 : investigationsData.investigationActivitiesPaginatedOffset) == null ? void 0 : _h.items) != null ? _i : [];
  (0,react.useEffect)(() => {
    if (patientDataError) {
      dist_default().error(
        formatMessage(
          {
            id: "patientHistory.patientData.fetch",
            defaultMessage: "Error fetching patient data: {error}"
          },
          { error: patientDataError.message }
        )
      );
    }
  }, [formatMessage, patientDataError]);
  (0,react.useEffect)(() => {
    if (clinicDataError) {
      dist_default().error(
        formatMessage(
          {
            id: "patientHistory.clinicData.fetch",
            defaultMessage: "Error fetching clinic data: {error}"
          },
          { error: clinicDataError.message }
        )
      );
    }
  }, [clinicDataError, formatMessage]);
  if (!patientData && patientDataLoading) {
    return /* @__PURE__ */ react.createElement(Loading/* default */.Z, null);
  }
  if (!patientData && patientDataError) {
    return /* @__PURE__ */ react.createElement(ErrorPage/* default */.Z, null);
  }
  const historicEvents = [
    ...consultations,
    ...investigations,
    ...inpatientVisits,
    ...encounters
  ];
  const historicEventsSortedByTime = historicEvents.sort((a, b) => {
    return new Date(b.meta.created).getTime() - new Date(a.meta.created).getTime();
  });
  return /* @__PURE__ */ react.createElement(History_Container, null, !!ongoingAdmissions && ongoingAdmissions.map((visit) => /* @__PURE__ */ react.createElement(CurrentInpatientCard/* default */.Z, {
    patientUuid: patient == null ? void 0 : patient.uuid,
    visitId: visit._id,
    "data-testid": "patient-details-current-inpatient-visit",
    key: visit._id
  })), /* @__PURE__ */ react.createElement(HistoricEventTimeline, {
    historicEvents: historicEventsSortedByTime,
    patient: {
      name: [
        patient.person.name.firstname,
        patient.person.name.middlename,
        patient.person.name.lastname
      ].filter(Boolean).join(" "),
      cardId: patientCardId,
      uuid: patient.uuid,
      gender: patient.person.gender,
      dob: (0,parse/* default */.Z)(patient.person.dob, "yyyy-MM-dd", new Date()),
      phoneNumber: (_m = (_l = (_k = (_j = patient.person.contactPoints) == null ? void 0 : _j.filter(
        (c) => c.system === "phone"
      )) == null ? void 0 : _k[0]) == null ? void 0 : _l.value) != null ? _m : void 0
    },
    facilityName: (_n = clinicData == null ? void 0 : clinicData.clinic.name) != null ? _n : "CLINIC NOT FOUND"
  }));
};
/* harmony default export */ const History_History = (History);

// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/History/__generated__/index.gql.ts
var index_gql = __webpack_require__(39551);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/History/index.tsx









const PatientConsultationFragment = lib/* gql */.Ps`
  # This is a fragment to allow us to query the same data when submitting new consultations, so that
  # it's available to present immediately when navigating back to patient history
  fragment PatientConsultationFragment on Consultation {
    id
    uuid
    clinic
    unit
    clinician
    problem
    presentingComplaint
    location {
      name
    }
    diagnoses {
      id
      code
      codification {
        name
        category
      }
      severity
      note
      onsetDateTime
      uuid
    }
    diseases {
      ...DiseaseDetails
    }
    plan
    patient
    meta {
      created
      active
      persistedAt
    }
    deliveredBy {
      ...UserDetails
    }
    prescriptions {
      ...OutpatientPrescriptionFragment
    }
  }
`;
lib/* gql */.Ps`
  ${PatientConsultationFragment}
  query getPatientConsultations($patientUuid: String!, $searchWholeTerritory: Boolean) {
    patientByCardId(uuid: $patientUuid, searchWholeTerritory: $searchWholeTerritory) {
      passportId # requesting this prevents collisions with other requests to the patientByCardId resolver
      patient {
        uuid # requesting this allows the consultations to be associated with the patient in the cache
        consultations {
          ...PatientConsultationFragment
        }
      }
    }
  }
`;
const HistoryTab = ({ patientUuid }) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const territoryDataSharingFeatureEnabled = (0,launchdarkly_provider_dist_module/* useFeatureFlag */.ye)(
    featureFlags/* featureFlags.patient.territoryDataSharing */.VH.patient.territoryDataSharing
  );
  const { loading, data, error } = (0,index_gql/* useGetPatientConsultationsQuery */.h6)({
    variables: {
      patientUuid,
      searchWholeTerritory: territoryDataSharingFeatureEnabled
    },
    onError: (e) => {
      dist_default().error(
        formatMessage(
          {
            id: "historyTab.noPatientFound.error",
            defaultMessage: "There was an error loading consultations: {error}"
          },
          { error: e.message }
        )
      );
    }
  });
  if (!data && error) {
    return null;
  }
  if (loading) {
    return /* @__PURE__ */ react.createElement(Loading/* default */.Z, {
      float: true
    });
  }
  return /* @__PURE__ */ react.createElement(History_History, {
    consultations: data.patientByCardId.patient.consultations,
    patientUuid
  });
};
/* harmony default export */ const Tabs_History = (HistoryTab);


/***/ }),

/***/ 57202:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ useCreateInvoice)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/index.js + 1 modules
var react_intl_lib = __webpack_require__(11313);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var dist = __webpack_require__(28841);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(28205);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/hooks/__generated__/useCreateInvoice.gql.ts


const defaultOptions = {};
const CreateInvoiceDocument = lib/* gql */.Ps`
    mutation createInvoice($input: CreateInvoiceInput!) {
  createInvoice(input: $input) {
    _id
    created
    invoiceNumber
    invoiceStatus
    patientType
    createdBy {
      person {
        firstname
        lastname
      }
      uuid
    }
    balance {
      total
      paid
      due
      currency
    }
  }
}
    `;
function useCreateInvoiceMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(CreateInvoiceDocument, options);
}

// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/hooks/__generated__/useFetchPatientInvoices.gql.ts
var useFetchPatientInvoices_gql = __webpack_require__(23033);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/hooks/useCreateInvoice.ts





const ERROR_MESSAGE = (0,react_intl_lib/* defineMessage */.Em)({
  id: "invoicing.createInvoice.error.msg",
  defaultMessage: "Failed to create a new invoice"
});
lib/* gql */.Ps`
  mutation createInvoice($input: CreateInvoiceInput!) {
    createInvoice(input: $input) {
      _id
      created
      invoiceNumber
      invoiceStatus
      patientType
      createdBy {
        person {
          firstname
          lastname
        }
        uuid
      }
      balance {
        total
        paid
        due
        currency
      }
    }
  }
`;
function useCreateInvoice(patientUuid) {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const [createInvoice] = useCreateInvoiceMutation({
    variables: {
      input: {
        patientUuid
      }
    },
    onError() {
      dist_default().error(formatMessage(ERROR_MESSAGE), {});
    },
    update: (cache, res) => {
      try {
        const cachedInvoices = cache.readQuery({
          query: useFetchPatientInvoices_gql/* InvoicesDocument */.cW,
          variables: { patientUuid }
        });
        if (cachedInvoices) {
          cache.writeQuery({
            query: useFetchPatientInvoices_gql/* InvoicesDocument */.cW,
            variables: { patientUuid },
            data: {
              invoices: [res.data.createInvoice, ...cachedInvoices.invoices]
            },
            broadcast: false
          });
        }
      } catch (e) {
      }
    }
  });
  return { createInvoice };
}


/***/ }),

/***/ 73378:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ Invoices)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/client/components/ErrorBoundary.tsx
var ErrorBoundary = __webpack_require__(60884);
// EXTERNAL MODULE: ./src/client/billing/BillingProvider.tsx + 1 modules
var BillingProvider = __webpack_require__(78768);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(948);
// EXTERNAL MODULE: ./src/client/components/Loading/index.ts
var Loading = __webpack_require__(80103);
// EXTERNAL MODULE: ./src/client/components/ErrorPage/index.tsx
var ErrorPage = __webpack_require__(64493);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/index.ts
var components = __webpack_require__(19626);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceFilters/index.ts + 2 modules
var InvoiceFilters = __webpack_require__(38617);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/hooks/useFetchPatientInvoices.ts
var useFetchPatientInvoices = __webpack_require__(45277);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.16.1/node_modules/date-fns/esm/isBefore/index.js
var isBefore = __webpack_require__(77508);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.16.1/node_modules/date-fns/esm/isAfter/index.js
var isAfter = __webpack_require__(47217);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.16.1/node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(45297);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceFilters/types.ts
var types = __webpack_require__(49361);
// EXTERNAL MODULE: ./src/client/utils/useQuerystring.ts
var useQuerystring = __webpack_require__(19894);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@6.15.0_react@18.1.0/node_modules/react-router/dist/index.js
var dist = __webpack_require__(76653);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/hooks/useFilteredInvoices.ts





const mapFilterToInvoiceStatuses = (value) => {
  switch (value) {
    case "ALL":
      return [
        types/* InvoiceStatus.Draft */.U.Draft,
        types/* InvoiceStatus.Paid */.U.Paid,
        types/* InvoiceStatus.PartiallyPaid */.U.PartiallyPaid,
        types/* InvoiceStatus.PartiallyRefunded */.U.PartiallyRefunded,
        types/* InvoiceStatus.Refunded */.U.Refunded,
        types/* InvoiceStatus.Unpaid */.U.Unpaid,
        types/* InvoiceStatus.Void */.U.Void
      ];
    case "PAID":
      return [types/* InvoiceStatus.Paid */.U.Paid, types/* InvoiceStatus.PartiallyRefunded */.U.PartiallyRefunded];
    case "UNPAID":
      return [
        types/* InvoiceStatus.Unpaid */.U.Unpaid,
        types/* InvoiceStatus.PartiallyPaid */.U.PartiallyPaid,
        types/* InvoiceStatus.Draft */.U.Draft
      ];
    case "REFUNDED":
      return [types/* InvoiceStatus.Refunded */.U.Refunded];
    case "VOID":
      return [types/* InvoiceStatus.Void */.U.Void];
    default:
      return [
        types/* InvoiceStatus.Draft */.U.Draft,
        types/* InvoiceStatus.Paid */.U.Paid,
        types/* InvoiceStatus.PartiallyPaid */.U.PartiallyPaid,
        types/* InvoiceStatus.PartiallyRefunded */.U.PartiallyRefunded,
        types/* InvoiceStatus.Refunded */.U.Refunded,
        types/* InvoiceStatus.Unpaid */.U.Unpaid,
        types/* InvoiceStatus.Void */.U.Void
      ];
  }
};
function useFilteredInvoices(invoices) {
  const { fromDate, toDate, invoiceStatus } = (0,useQuerystring/* default */.Z)();
  const navigate = (0,dist/* useNavigate */.s0)();
  const location = (0,dist/* useLocation */.TH)();
  const replaceQueryParam = (key) => (value) => {
    const existingParams = new URLSearchParams(location.search);
    existingParams.set(key, value);
    navigate(
      { pathname: location.pathname, search: existingParams.toString() },
      { replace: true }
    );
  };
  const filteredInvoices = (0,react.useMemo)(() => {
    return invoices.filter((invoice) => {
      var _a;
      if (invoiceStatus && !mapFilterToInvoiceStatuses(invoiceStatus).includes(
        (_a = invoice == null ? void 0 : invoice.invoiceSummary) == null ? void 0 : _a.invoiceStatus
      )) {
        return false;
      }
      if (fromDate && (0,isBefore/* default */.Z)(new Date(invoice == null ? void 0 : invoice.invoiceSummary.created), new Date(fromDate))) {
        return false;
      }
      if (toDate && (0,isAfter/* default */.Z)(
        new Date(invoice == null ? void 0 : invoice.invoiceSummary.created),
        (0,addDays/* default */.Z)(new Date(toDate), 1)
      )) {
        return false;
      }
      return true;
    });
  }, [invoices, fromDate, toDate, invoiceStatus]);
  return {
    filteredInvoices,
    fromDate,
    toDate,
    invoiceStatus,
    setFromDate: replaceQueryParam("fromDate"),
    setToDate: replaceQueryParam("toDate"),
    setInvoiceStatus: replaceQueryParam("invoiceStatus")
  };
}

// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(90322);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/index.js + 1 modules
var react_intl_lib = __webpack_require__(11313);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var mui_toast_dist = __webpack_require__(28841);
var dist_default = /*#__PURE__*/__webpack_require__.n(mui_toast_dist);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/hooks/useFetchPriceList.tsx




const ERROR_MESSAGE = (0,react_intl_lib/* defineMessage */.Em)({
  id: "invoicing.getPriceList.error.msg",
  defaultMessage: "Failed to fetch price list"
});
const META_QUERY = lib/* gql */.Ps`
  query priceListMeta {
    priceList {
      meta {
        version
        updated
      }
    }
  }
`;
const QUERY = lib/* gql */.Ps`
  query priceList {
    priceList {
      prices {
        uuid
        name
        payers {
          name
          amountInPence
        }
      }
      meta {
        version
        updated
      }
    }
  }
`;
const METADATA_POLL_INTERVAL = 30 * 6e4;
function useFetchPriceList(pollInterval = METADATA_POLL_INTERVAL) {
  const [priceListItems, setPriceListItems] = (0,react.useState)(null);
  const [priceListVersion, setPriceListVersion] = (0,react.useState)(null);
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const {
    data: metaData,
    loading: metaLoading,
    error: metaError
  } = (0,useQuery/* useQuery */.a)(META_QUERY, {
    fetchPolicy: "no-cache",
    pollInterval,
    onError() {
      dist_default().error(formatMessage(ERROR_MESSAGE), {});
    }
  });
  const [fetchPrices, { data, loading, error }] = (0,useLazyQuery/* useLazyQuery */.t)(QUERY, {
    fetchPolicy: "cache-and-network",
    onError() {
      dist_default().error(formatMessage(ERROR_MESSAGE), {});
    }
  });
  (0,react.useEffect)(() => {
    if (metaLoading || metaError) {
      return;
    }
    if (priceListVersion !== metaData.priceList.meta.version) {
      setPriceListVersion(metaData.priceList.meta.version);
      fetchPrices();
    }
  }, [
    metaData,
    metaLoading,
    metaError,
    priceListVersion,
    setPriceListVersion,
    fetchPrices
  ]);
  (0,react.useEffect)(() => {
    if (loading || error || !data) {
      return;
    }
    setPriceListItems(data.priceList.prices);
  }, [data, loading, error, setPriceListItems]);
  return { loading, error, priceList: { version: 1, priceListItems } };
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+user-context-provider@1.3.0_whclspbtx7fcz5jo6nehkthzny/node_modules/@elephant-healthcare/user-context-provider/dist/module.js
var dist_module = __webpack_require__(36547);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/hooks/__generated__/useFetchPriceListV2.gql.ts


const defaultOptions = {};
const InvoicingPriceListV2MetaDocument = lib/* gql */.Ps`
    query invoicingPriceListV2Meta($input: PriceListMetaInput!) {
  priceListV2 {
    priceListMeta(input: $input) {
      id
    }
  }
}
    `;
function useInvoicingPriceListV2MetaQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(InvoicingPriceListV2MetaDocument, options);
}
function useInvoicingPriceListV2MetaLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(InvoicingPriceListV2MetaDocument, options);
}
const InvoicingPriceListV2Document = lib/* gql */.Ps`
    query invoicingPriceListV2($input: PriceListItemsInput!, $options: PriceListItemsOptions) {
  priceListV2 {
    priceListItems(input: $input, options: $options) {
      edges {
        id
        name
        externalReference {
          origin
          foreignId
        }
        prices {
          id
          value
          tariff {
            id
            name
          }
          revenueDepartment {
            name
          }
        }
      }
    }
  }
}
    `;
function useInvoicingPriceListV2Query(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(InvoicingPriceListV2Document, options);
}
function useInvoicingPriceListV2LazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useLazyQuery/* useLazyQuery */.t(InvoicingPriceListV2Document, options);
}

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/hooks/useFetchPriceListV2.tsx






const useFetchPriceListV2_ERROR_MESSAGE = (0,react_intl_lib/* defineMessage */.Em)({
  id: "invoicing.getPriceList.error.msg",
  defaultMessage: "Failed to fetch price list"
});
lib/* gql */.Ps`
  query invoicingPriceListV2Meta($input: PriceListMetaInput!) {
    priceListV2 {
      priceListMeta(input: $input) {
        id
      }
    }
  }
`;
lib/* gql */.Ps`
  query invoicingPriceListV2($input: PriceListItemsInput!, $options: PriceListItemsOptions) {
    priceListV2 {
      priceListItems(input: $input, options: $options) {
        edges {
          id
          name
          externalReference {
            origin
            foreignId
          }
          prices {
            id
            value
            tariff {
              id
              name
            }
            revenueDepartment {
              name
            }
          }
        }
      }
    }
  }
`;
function useFetchPriceListV2() {
  const { facilityId } = (0,dist_module/* useUserContext */.SE)();
  const [priceListId, setPriceListId] = (0,react.useState)(null);
  const [priceListItems, setPriceListItems] = (0,react.useState)([]);
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const {
    data: metaData,
    loading: metaLoading,
    error: metaError
  } = useInvoicingPriceListV2MetaQuery({
    variables: { input: { facilityId } },
    fetchPolicy: "no-cache",
    onError() {
      dist_default().error(formatMessage(useFetchPriceListV2_ERROR_MESSAGE), {});
    }
  });
  const [fetchPrices, { data, loading, error }] = useInvoicingPriceListV2LazyQuery({
    variables: {
      input: { priceListId },
      options: { pagination: { pageSize: 1e5 } }
    },
    fetchPolicy: "cache-and-network",
    onError() {
      dist_default().error(formatMessage(useFetchPriceListV2_ERROR_MESSAGE), {});
    }
  });
  (0,react.useEffect)(() => {
    var _a;
    if (metaLoading || metaError || !((_a = metaData == null ? void 0 : metaData.priceListV2.priceListMeta) == null ? void 0 : _a.id)) {
      return;
    }
    setPriceListId(metaData.priceListV2.priceListMeta.id);
  }, [metaData, metaLoading, metaError, setPriceListId]);
  (0,react.useEffect)(() => {
    if (priceListId) {
      fetchPrices();
    }
  }, [priceListId, fetchPrices]);
  (0,react.useEffect)(() => {
    if (loading || error || !data) {
      return;
    }
    const edges = data.priceListV2.priceListItems.edges.map(
      (e) => ({
        ...e,
        payers: e.prices.map((p) => ({
          tariffId: p.tariff.id,
          name: p.tariff.name,
          amountInPence: p.value,
          revenueDepartment: p.revenueDepartment.name
        }))
      })
    );
    setPriceListItems(edges);
  }, [data, loading, error, setPriceListItems]);
  return { loading, error, priceList: { version: 2, priceListItems } };
}

// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-style@0.2.18_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-style/dist/module.js
var mui_style_dist_module = __webpack_require__(10353);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var mui_button_dist_module = __webpack_require__(2550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-icon@0.3.15_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-icon/dist/module.js
var mui_icon_dist_module = __webpack_require__(46828);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/images/emptyState.svg
const emptyState_namespaceObject = __webpack_require__.p + "assets/emptyState.svg";
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/hooks/useCreateInvoice.ts + 1 modules
var useCreateInvoice = __webpack_require__(57202);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoicingEmptyState.tsx









const useStyles = (0,mui_style_dist_module/* makeStyles */.Z)(() => ({
  emptyStateImage: {
    margin: "20px auto",
    width: "100px"
  }
}));
const InvoicingEmptyState = () => {
  const classes = useStyles();
  const { patientUuid } = (0,useQuerystring/* default */.Z)();
  const { createInvoice } = (0,useCreateInvoice/* default */.Z)(patientUuid);
  const createNewInvoice = (0,react.useCallback)(
    async () => createInvoice(),
    [createInvoice]
  );
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    textAlign: "center",
    py: 5
  }, /* @__PURE__ */ react.createElement("img", {
    className: classes.emptyStateImage,
    src: emptyState_namespaceObject,
    alt: ""
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1"
  }, /* @__PURE__ */ react.createElement("b", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.emptyState.title",
    defaultMessage: "No invoices yet"
  }))), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    gutterBottom: true,
    variant: "body2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.emptyState.description",
    defaultMessage: "Invoices created for this patient will appear here"
  })), /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    startIcon: /* @__PURE__ */ react.createElement(mui_icon_dist_module.PlusIconBorderless, null),
    variant: "text",
    color: "secondary",
    onClick: createNewInvoice
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.emptyState.buttonLabel",
    defaultMessage: "Create invoice"
  })));
};
/* harmony default export */ const components_InvoicingEmptyState = (InvoicingEmptyState);

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/EmptySearchState.tsx





const EmptySearchState_useStyles = (0,mui_style_dist_module/* makeStyles */.Z)(() => ({
  emptyStateContainer: {
    textAlign: "center"
  },
  emptyStateImage: {
    margin: "20px auto",
    width: "100px"
  }
}));
const EmptySearchState = () => {
  const classes = EmptySearchState_useStyles();
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12,
    className: classes.emptyStateContainer
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, null, /* @__PURE__ */ react.createElement("img", {
    className: classes.emptyStateImage,
    src: emptyState_namespaceObject,
    alt: ""
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1"
  }, /* @__PURE__ */ react.createElement("b", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.emptySearchState.title",
    defaultMessage: "There are no invoices for the status and dates you have selected"
  })))));
};
/* harmony default export */ const components_EmptySearchState = (EmptySearchState);

// EXTERNAL MODULE: ./src/client/common/featureFlags/index.ts
var featureFlags = __webpack_require__(72766);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/__generated__/TabContent.gql.ts


const TabContent_gql_defaultOptions = {};
const InsuranceProvidersDocument = lib/* gql */.Ps`
    query InsuranceProviders {
  minInsuranceProviders {
    id
    name
    insuranceType
    properties
  }
}
    `;
function useInsuranceProvidersQuery(baseOptions) {
  const options = { ...TabContent_gql_defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(InsuranceProvidersDocument, options);
}
function useInsuranceProvidersLazyQuery(baseOptions) {
  const options = { ...TabContent_gql_defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(InsuranceProvidersDocument, options);
}

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/TabContent.tsx

















lib/* gql */.Ps`
  query InsuranceProviders {
    minInsuranceProviders {
      id
      name
      insuranceType
      properties
    }
  }
`;
function capitaliseDependentsEnum(minInsuranceProviders) {
  return minInsuranceProviders.map((i) => {
    var _a;
    return {
      ...i,
      properties: (_a = i.properties) == null ? void 0 : _a.map((p) => {
        var _a2;
        if (p.name === "dependent") {
          return {
            ...p,
            enum: (_a2 = p.enum) == null ? void 0 : _a2.map((e) => e.toUpperCase())
          };
        }
        return p;
      })
    };
  });
}
const TabContent = ({ patientUuid }) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const priceListV2Enabled = (0,featureFlags/* useFeatureFlag */.ye)(
    featureFlags/* featureFlags.billing.usePriceListV2 */.VH.billing.usePriceListV2
  );
  const priceListHook = priceListV2Enabled ? useFetchPriceListV2 : useFetchPriceList;
  const { priceList } = priceListHook();
  const { data: insurersData, loading: insurersLoading } = useInsuranceProvidersQuery({
    fetchPolicy: "cache-and-network",
    onError() {
      dist_default().error(
        formatMessage({
          id: "invoicing.getInsurers.error.msg",
          defaultMessage: "Failed to fetch the insurers for this territory"
        })
      );
    }
  });
  const { invoices, loading, error } = (0,useFetchPatientInvoices/* default */.Z)(patientUuid);
  const { filteredInvoices, ...invoiceFilters } = useFilteredInvoices(invoices);
  if (loading && invoices.length === 0 || insurersLoading)
    return /* @__PURE__ */ react.createElement(Loading/* default */.Z, null);
  if (error)
    return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
      p: 3
    }, /* @__PURE__ */ react.createElement(ErrorPage/* default */.Z, {
      error
    }));
  if (!loading && invoices.length === 0) {
    return /* @__PURE__ */ react.createElement(components_InvoicingEmptyState, null);
  }
  const insurers = capitaliseDependentsEnum(
    insurersData == null ? void 0 : insurersData.minInsuranceProviders
  );
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    spacing: 2
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(InvoiceFilters/* InvoiceFilters */.A$, {
    ...invoiceFilters
  })), filteredInvoices.length < 1 ? /* @__PURE__ */ react.createElement(components_EmptySearchState, null) : filteredInvoices == null ? void 0 : filteredInvoices.map((invoice) => {
    var _a;
    return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
      item: true,
      xs: 12,
      key: (_a = invoice == null ? void 0 : invoice.invoiceSummary) == null ? void 0 : _a.invoiceNumber
    }, /* @__PURE__ */ react.createElement(components/* InvoiceCard */.PZ, {
      ...invoice,
      priceList,
      insurers,
      balance: invoice.invoiceSummary.balance
    }));
  }));
};
/* harmony default export */ const Invoices_TabContent = (TabContent);

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/index.tsx




const InvoicingTab = ({ patientUuid }) => {
  return /* @__PURE__ */ react.createElement(ErrorBoundary/* default */.Z, {
    name: "invoicing-tab"
  }, /* @__PURE__ */ react.createElement(BillingProvider/* default */.ZP, null, /* @__PURE__ */ react.createElement(Invoices_TabContent, {
    patientUuid
  })));
};
/* harmony default export */ const Invoices = (InvoicingTab);


/***/ })

}]);